import P6 from "@ui-kit/components/modal";
import k6 from "@ui-kit/components/button";
import T6 from "@ui-kit/components/pdf";
import { defineComponent as m, computed as p, openBlock as a, createElementBlock as f, createStaticVNode as N6, createCommentVNode as _, toRef as D, toDisplayString as Z, createVNode as b, renderSlot as A, createTextVNode as K, createElementVNode as g, unref as n, createBlock as L, defineAsyncComponent as s, resolveComponent as I, withCtx as T, useModel as R, watch as J, createSlots as M6, mergeModels as Z6, toValue as x6, normalizeStyle as D6, Fragment as W, renderList as a6, normalizeClass as A6, toRefs as E6, ref as U, useSlots as K6, nextTick as I6, withDirectives as Y, vShow as Q } from "vue";
import { useI18n as q } from "vue-i18n";
import { UIProgressCircular as q6 } from "@ui-kit/components/progress";
import { useAppFieldResponse as o6, formatCurrency as R6, RoundingMode as X, downloadContent as U6, downloadUrl as z6, extractProviderKey as $6, useProviderI18n as t6, useCurrentStaticProviderKey as j6, useProviderConfig as e6, formatPercent as G6, useLogger as O6, reportSessionError as W6 } from "@versatile-credit-apply/sdk";
import { faDownload as Y6 } from "@fortawesome/pro-regular-svg-icons";
import { useIsContentDownloadSupported as Q6, useIsInStore as J6 } from "@versatile-credit-apply/composition";
import { FontAwesomeIcon as X6 } from "@fortawesome/vue-fontawesome";
const t1 = {
  key: 0,
  class: "w-full"
}, q1 = /* @__PURE__ */ m({
  __name: "CheckDetails",
  setup(e) {
    const t = o6("bankAccount.routingNumber"), o = o6("bankAccount.accountNumber"), C = p(() => t.value && o.value);
    return (i, l) => C.value ? (a(), f("div", t1, [...l[0] || (l[0] = [
      N6('<svg viewBox="0 0 350 66" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1101_593)"><path d="M350 0.666656H0V28.6667H350V0.666656Z" fill="#DBEAFE"></path><path d="M17.3389 17.2706V19.9096L17.2549 20.2386L17.0169 20.4836L16.6879 20.5676H13.8949L13.5589 20.4836L13.3139 20.2386L13.2299 19.9096V17.2706L13.3139 16.9346L13.5589 16.6896L13.8949 16.6056H16.6879L17.0169 16.6966L17.2549 16.9346L17.3389 17.2706ZM10.0869 18.5866H8.71488L8.38588 18.4956L8.14088 18.2576L8.05688 17.9216V11.3206L8.14088 10.9916L8.38588 10.7536L8.71488 10.6626H10.0869L10.4159 10.7536L10.6539 10.9916L10.7449 11.3206V17.9216L10.6539 18.2576L10.4159 18.4956L10.0869 18.5866ZM13.2299 9.35362L13.3139 9.02462L13.5589 8.77962L13.8949 8.69562H16.6879L17.0169 8.77962L17.2549 9.02462L17.3389 9.35362V11.9926L17.2549 12.3216L17.0169 12.5666L16.6879 12.6506H13.8949L13.5589 12.5596L13.3139 12.3146L13.2299 11.9856V9.34662V9.35362ZM30.0229 17.9286L30.0089 18.1736L29.9529 18.5236L29.8479 18.8596L29.7079 19.1886L29.5189 19.4826L29.2879 19.7486L29.0289 19.9936L28.7349 20.1966L28.4269 20.3576L28.0839 20.4696L27.7409 20.5466L27.3909 20.5676H22.7849L22.4349 20.4976L22.0919 20.3926L21.7769 20.2526L21.4759 20.0636L21.2099 19.8396L20.9649 19.5736L20.7689 19.2866L20.6079 18.9646L20.4889 18.6286L20.4189 18.2856L20.3909 17.9356V11.3346L20.4049 11.0896L20.4539 10.7396L20.5589 10.4036L20.7059 10.0746L20.8949 9.78062L21.1329 9.51462L21.3919 9.26962L21.6859 9.06662L22.0009 8.90562L22.3369 8.79362L22.6869 8.71662L23.0369 8.69562H27.6429L27.9929 8.76562L28.3289 8.87062L28.6509 9.01062L28.9519 9.19962L29.2179 9.42362L29.4559 9.68962L29.6589 9.97662L29.8199 10.2986L29.9389 10.6276L30.0089 10.9776L30.0369 11.3276V17.9286H30.0229ZM28.7069 17.9286V11.3276L28.6579 10.9776L28.5249 10.6556L28.3009 10.3756L28.0139 10.1656L27.6849 10.0396L27.3909 10.0046H23.0299L22.6799 10.0466L22.3439 10.1936L22.0709 10.4106L21.8679 10.6906L21.7349 11.0266L21.6999 11.3206V17.9216L21.7489 18.2716L21.8819 18.5936L22.1059 18.8736L22.3929 19.0836L22.7219 19.2096L23.0229 19.2376H27.3839L27.7339 19.1956L28.0629 19.0556L28.3429 18.8386L28.5459 18.5516L28.6719 18.2156L28.7069 17.9216V17.9286ZM38.0379 15.2896L37.7369 15.3736L37.5129 15.5906L37.4359 15.8986V19.9096L37.5199 20.2386L37.7649 20.4836L38.0939 20.5676H42.0559L42.3849 20.4836L42.6299 20.2386L42.7139 19.9096V15.9476L42.6299 15.6186L42.3849 15.3736L42.0559 15.2896H40.7329L40.3969 15.1986L40.1589 14.9536L40.0749 14.6246V9.34662L39.9839 9.01762L39.7389 8.77262L39.4099 8.68862H38.0869L37.7579 8.77262L37.5129 9.01762L37.4289 9.34662V10.0116L37.5129 10.3336L37.7579 10.5786L38.0869 10.6626H38.1359L38.4579 10.7466L38.6609 10.9706L38.7449 11.2646V14.6176L38.6609 14.9466L38.4159 15.1916L38.0869 15.2826H38.0379V15.2896ZM50.7289 15.2896L50.4279 15.3736L50.2039 15.5906L50.1269 15.8986V19.9096L50.2109 20.2386L50.4559 20.4836L50.7849 20.5676H54.7469L55.0759 20.4836L55.3209 20.2386L55.4049 19.9096V15.9476L55.3209 15.6186L55.0759 15.3736L54.7469 15.2896H53.4239L53.0879 15.1986L52.8499 14.9536L52.7659 14.6246V9.34662L52.6749 9.01762L52.4299 8.77262L52.1009 8.68862H50.7779L50.4489 8.77262L50.2039 9.01762L50.1199 9.34662V10.0116L50.2039 10.3336L50.4489 10.5786L50.7779 10.6626H50.8269L51.1489 10.7466L51.3519 10.9706L51.4359 11.2646V14.6176L51.3519 14.9466L51.1069 15.1916L50.7779 15.2826H50.7289V15.2896ZM64.8059 13.9666H62.1179L61.8029 14.0506L61.5719 14.2886L61.4879 14.6036V14.6526L61.5719 14.9676L61.8029 15.2056L62.1179 15.2896H64.8059L65.1279 15.3736L65.3589 15.6116L65.4429 15.9266V18.6146L65.3589 18.9296L65.1279 19.1676L64.8059 19.2516H62.1179L61.8029 19.3286L61.5719 19.5596L61.4879 19.8816V19.9306L61.5719 20.2456L61.8029 20.4766L62.1179 20.5606H67.4449L67.7599 20.4766L67.9979 20.2456L68.0819 19.9306V15.2686L67.9979 14.9466L67.7599 14.7156L67.4449 14.6316H67.3959L67.0809 14.5476L66.8499 14.3096L66.7589 14.0016V9.32562L66.6749 9.01762L66.4439 8.78662L66.1289 8.69562H62.1179L61.8029 8.78662L61.5719 9.01762L61.4249 9.34662L61.4879 9.38162L61.5719 9.69662L61.8029 9.93462L62.1179 10.0186H64.8059L65.1279 10.1026L65.3589 10.3336L65.4429 10.6556V13.3436L65.3589 13.6656L65.1279 13.8966L64.8059 13.9806V13.9666ZM80.7729 17.9286L80.7589 18.1736L80.7029 18.5236L80.5979 18.8596L80.4579 19.1886L80.2689 19.4826L80.0379 19.7486L79.7789 19.9936L79.4849 20.1966L79.1769 20.3576L78.8339 20.4696L78.4909 20.5466L78.1409 20.5676H73.5349L73.1849 20.4976L72.8419 20.3926L72.5269 20.2526L72.2259 20.0636L71.9599 19.8396L71.7149 19.5736L71.5189 19.2866L71.3579 18.9646L71.2389 18.6286L71.1689 18.2856L71.1409 17.9356V11.3346L71.1549 11.0896L71.2039 10.7396L71.3089 10.4036L71.4559 10.0746L71.6449 9.78062L71.8829 9.51462L72.1419 9.26962L72.4359 9.06662L72.7509 8.90562L73.0869 8.79362L73.4369 8.71662L73.7869 8.69562H78.3929L78.7429 8.76562L79.0789 8.87062L79.4009 9.01062L79.7019 9.19962L79.9679 9.42362L80.2059 9.68962L80.4089 9.97662L80.5699 10.2986L80.6889 10.6276L80.7589 10.9776L80.7869 11.3276V17.9286H80.7729ZM79.4569 17.9286V11.3276L79.4079 10.9776L79.2749 10.6556L79.0509 10.3756L78.7639 10.1656L78.4349 10.0396L78.1339 10.0046H73.7729L73.4229 10.0466L73.0869 10.1936L72.8139 10.4106L72.6109 10.6906L72.4779 11.0266L72.4429 11.3206V17.9216L72.4919 18.2716L72.6249 18.5936L72.8489 18.8736L73.1359 19.0836L73.4649 19.2096L73.7659 19.2376H78.1269L78.4769 19.1956L78.8059 19.0556L79.0859 18.8386L79.2889 18.5516L79.4149 18.2156L79.4499 17.9216L79.4569 17.9286ZM93.4639 17.9286L93.4499 18.1736L93.3939 18.5236L93.2889 18.8596L93.1489 19.1886L92.9599 19.4826L92.7289 19.7486L92.4699 19.9936L92.1759 20.1966L91.8679 20.3576L91.5249 20.4696L91.1819 20.5466L90.8319 20.5676H86.2259L85.8759 20.4976L85.5329 20.3926L85.2179 20.2526L84.9169 20.0636L84.6509 19.8396L84.4059 19.5736L84.2099 19.2866L84.0489 18.9646L83.9299 18.6286L83.8599 18.2856L83.8319 17.9356V11.3346L83.8459 11.0896L83.8949 10.7396L83.9999 10.4036L84.1469 10.0746L84.3289 9.78062L84.5669 9.51462L84.8259 9.26962L85.1199 9.06662L85.4349 8.90562L85.7709 8.79362L86.1209 8.71662L86.4709 8.69562H91.0769L91.4269 8.76562L91.7629 8.87062L92.0849 9.01062L92.3859 9.19962L92.6519 9.42362L92.8899 9.68962L93.0929 9.97662L93.2539 10.2986L93.3729 10.6276L93.4429 10.9776L93.4709 11.3276V17.9286H93.4639ZM92.1409 17.9286V11.3276L92.0919 10.9776L91.9589 10.6556L91.7349 10.3756L91.4479 10.1656L91.1189 10.0396L90.8179 10.0046H86.4569L86.1069 10.0466L85.7709 10.1936L85.4979 10.4106L85.2949 10.6906L85.1619 11.0266L85.1269 11.3206V17.9216L85.1759 18.2716L85.3089 18.5936L85.5329 18.8736L85.8199 19.0836L86.1489 19.2096L86.4499 19.2376H90.8109L91.1609 19.1956L91.4899 19.0556L91.7699 18.8386L91.9729 18.5516L92.0989 18.2156L92.1339 17.9216L92.1409 17.9286ZM101.479 15.2896L101.178 15.3736L100.954 15.5906L100.87 15.8986V19.9096L100.954 20.2386L101.199 20.4836L101.528 20.5676H105.483L105.812 20.4836L106.057 20.2386L106.141 19.9096V15.9476L106.057 15.6186L105.812 15.3736L105.483 15.2896H104.16L103.824 15.1986L103.586 14.9536L103.502 14.6246V9.34662L103.411 9.01762L103.166 8.77262L102.837 8.68862H101.521L101.192 8.77262L100.947 9.01762L100.863 9.34662V10.0116L100.947 10.3336L101.192 10.5786L101.521 10.6626H101.57L101.892 10.7466L102.095 10.9706L102.172 11.2646V14.6176L102.088 14.9466L101.843 15.1916L101.514 15.2826H101.465L101.479 15.2896ZM116.207 15.9546L116.13 16.2766L115.892 16.5076L115.577 16.5916H114.205L113.883 16.5076L113.652 16.2766L113.568 15.9546V9.30462L113.491 8.98962L113.253 8.75862L112.938 8.67462H111.566L111.244 8.75862L111.013 8.98962L110.929 9.30462V17.2776L111.013 17.5856L111.244 17.8236L111.566 17.9076H115.577L115.892 17.9916L116.13 18.2226L116.207 18.5376V19.9096L116.291 20.2176L116.522 20.4556L116.844 20.5396H118.209L118.531 20.4556L118.762 20.2176L118.839 19.9096V15.8986L118.762 15.5836L118.531 15.3456L118.209 15.2686H116.844L116.522 15.3456L116.291 15.5836L116.207 15.8986V15.9476V15.9546ZM126.028 9.01762L126.273 8.77262L126.602 8.68862H130.865L131.194 8.77262L131.439 9.01762L131.523 9.35362V14.6316L131.439 14.9606L131.194 15.1986L130.865 15.2896H127.925L127.596 15.3736L127.351 15.6186L127.26 15.9476V18.5866L127.344 18.9156L127.589 19.1606L127.918 19.2446H130.907L131.208 19.3286L131.439 19.5456L131.516 19.8956L131.432 20.2316L131.187 20.4766L130.858 20.5606H126.595L126.266 20.4766L126.021 20.2316L125.937 19.8956V14.6246L126.021 14.2886L126.266 14.0506L126.595 13.9596H129.535L129.864 13.8756L130.109 13.6306L130.193 13.2946V10.6556L130.109 10.3266L129.864 10.0886L129.535 10.0046H126.595L126.266 9.91362L126.021 9.66862L125.937 9.33962L126.021 9.00362L126.028 9.01762ZM144.214 17.2706V19.9096L144.13 20.2386L143.892 20.4836L143.563 20.5676H140.77L140.434 20.4836L140.189 20.2386L140.105 19.9096V17.2706L140.189 16.9346L140.434 16.6896L140.77 16.6056H143.563L143.892 16.6966L144.13 16.9346L144.214 17.2706ZM136.962 18.5866H135.59L135.261 18.4956L135.016 18.2576L134.932 17.9216V11.3206L135.016 10.9916L135.261 10.7536L135.59 10.6626H136.962L137.291 10.7536L137.529 10.9916L137.62 11.3206V17.9216L137.529 18.2576L137.291 18.4956L136.962 18.5866ZM140.105 9.35362L140.189 9.02462L140.434 8.77962L140.77 8.69562H143.563L143.892 8.77962L144.13 9.02462L144.214 9.35362V11.9926L144.13 12.3216L143.892 12.5666L143.563 12.6506H140.77L140.434 12.5596L140.189 12.3146L140.105 11.9856V9.34662V9.35362ZM164.913 15.2896L164.612 15.3736L164.388 15.5906L164.304 15.8986V19.9096L164.388 20.2386L164.633 20.4836L164.962 20.5676H168.917L169.246 20.4836L169.491 20.2386L169.575 19.9096V15.9476L169.491 15.6186L169.246 15.3736L168.917 15.2896H167.594L167.258 15.1986L167.02 14.9536L166.936 14.6246V9.34662L166.845 9.01762L166.6 8.77262L166.271 8.68862H164.955L164.626 8.77262L164.381 9.01762L164.297 9.34662V10.0116L164.381 10.3336L164.626 10.5786L164.955 10.6626H165.004L165.326 10.7466L165.529 10.9706L165.606 11.2646V14.6176L165.522 14.9466L165.277 15.1916L164.948 15.2826H164.899L164.913 15.2896ZM176.778 9.01762L177.023 8.77262L177.352 8.68862H181.615L181.944 8.77262L182.189 9.01762L182.273 9.35362V14.6316L182.189 14.9606L181.944 15.1986L181.615 15.2896H178.675L178.346 15.3736L178.101 15.6186L178.01 15.9476V18.5866L178.094 18.9156L178.339 19.1606L178.668 19.2446H181.657L181.958 19.3286L182.189 19.5456L182.266 19.8956L182.182 20.2316L181.937 20.4766L181.608 20.5606H177.345L177.016 20.4766L176.771 20.2316L176.687 19.8956V14.6246L176.771 14.2886L177.016 14.0506L177.345 13.9596H180.285L180.614 13.8756L180.859 13.6306L180.943 13.2946V10.6556L180.859 10.3266L180.614 10.0886L180.285 10.0046H177.345L177.016 9.91362L176.771 9.66862L176.687 9.33962L176.771 9.00362L176.778 9.01762ZM191.681 13.9666H188.993L188.678 14.0506L188.447 14.2886L188.363 14.6036V14.6526L188.447 14.9676L188.678 15.2056L188.993 15.2896H191.681L192.003 15.3736L192.234 15.6116L192.318 15.9266V18.6146L192.234 18.9296L192.003 19.1676L191.681 19.2516H188.993L188.678 19.3286L188.447 19.5596L188.363 19.8816V19.9306L188.447 20.2456L188.678 20.4766L188.993 20.5606H194.32L194.635 20.4766L194.873 20.2456L194.957 19.9306V15.2686L194.873 14.9466L194.635 14.7156L194.32 14.6316H194.271L193.956 14.5476L193.725 14.3096L193.634 14.0016V9.32562L193.55 9.01762L193.319 8.78662L193.004 8.69562H188.993L188.678 8.78662L188.447 9.01762L188.3 9.34662L188.363 9.38162L188.447 9.69662L188.678 9.93462L188.993 10.0186H191.681L192.003 10.1026L192.234 10.3336L192.318 10.6556V13.3436L192.234 13.6656L192.003 13.8966L191.681 13.9806V13.9666ZM205.016 15.9546L204.932 16.2766L204.694 16.5076L204.379 16.5916H203.007L202.685 16.5076L202.454 16.2766L202.37 15.9546V9.30462L202.286 8.98962L202.048 8.75862L201.733 8.67462H200.368L200.046 8.75862L199.815 8.98962L199.731 9.30462V17.2776L199.815 17.5856L200.046 17.8236L200.368 17.9076H204.379L204.694 17.9916L204.932 18.2226L205.016 18.5376V19.9096L205.1 20.2176L205.331 20.4556L205.653 20.5396H207.018L207.34 20.4556L207.571 20.2176L207.648 19.9096V15.8986L207.571 15.5836L207.34 15.3456L207.018 15.2686H205.653L205.331 15.3456L205.1 15.5836L205.016 15.8986V15.9476V15.9546ZM214.851 10.6416V13.3296L214.935 13.6516L215.173 13.8826L215.488 13.9666H219.702L220.024 14.0576L220.255 14.2886L220.339 14.6036V19.9376L220.255 20.2456L220.024 20.4836L219.702 20.5676H214.172L213.857 20.4836L213.626 20.2456L213.542 19.9376V19.8816L213.626 19.5666L213.857 19.3286L214.172 19.2446H218.344L218.652 19.1606L218.89 18.9296L218.974 18.6076V15.9196L218.89 15.6046L218.652 15.3666L218.344 15.2896H214.172L213.857 15.2056L213.626 14.9676L213.542 14.6526V9.32562L213.626 9.01062L213.857 8.77962L214.172 8.69562H219.702L220.024 8.77962L220.255 9.01062L220.339 9.37462L220.255 9.69662L220.024 9.92762L219.702 10.0116H215.488L215.173 10.0956L214.935 10.3336L214.851 10.6486V10.6416ZM233.023 19.9306L232.946 20.2386L232.708 20.4766L232.393 20.5606H225.491L225.176 20.4766L224.938 20.2386L224.847 19.9306V9.31862L224.938 9.00362L225.176 8.77262L225.491 8.68862H229.754L230.069 8.77262L230.307 9.00362L230.384 9.31862V11.3486L230.307 11.6636L230.069 11.8946L229.621 11.9856L229.306 11.8946L229.075 11.6636L228.991 11.3486V10.6346L228.907 10.3196L228.676 10.0816L228.361 9.99762H226.807L226.499 10.0816L226.261 10.3196L226.177 10.6346V14.6456L226.261 14.9676L226.499 15.1986L226.807 15.2826H232.393L232.708 15.3596L232.946 15.6046L233.023 15.9126V19.9236V19.9306ZM231.63 18.6496V17.2426L231.546 16.9206L231.315 16.6896L231 16.6056H226.807L226.499 16.6896L226.261 16.9206L226.177 17.2426V18.6076L226.261 18.9296L226.499 19.1606L226.807 19.2446H231L231.315 19.1606L231.546 18.9296L231.63 18.6496ZM243.516 14.6386L243.236 14.8136L243.082 15.1076L243.068 15.2406V19.9236L242.984 20.2386L242.753 20.4696L242.249 20.5536H242.207L241.885 20.4696L241.654 20.2386L241.57 19.9236V14.4566L241.598 14.2816L241.766 13.9946L242.053 13.8336L243.908 13.4136L244.202 13.2596L244.37 12.9726L244.398 12.7976V10.6276L244.314 10.3126L244.076 10.0746L243.768 9.99062H240.891L240.576 10.0746L240.338 10.3126L240.254 10.6276V11.9996L240.177 12.3146L239.946 12.5526L239.624 12.6366H239.575L239.26 12.5526L239.029 12.3146L238.945 11.9996V9.31162L239.029 8.99662L239.26 8.76562L239.575 8.68162H245.084L245.406 8.76562L245.637 8.99662L245.721 9.31162V13.4836L245.7 13.6236L245.546 13.9176L245.273 14.0926L243.523 14.6316L243.516 14.6386ZM258.398 19.9306L258.321 20.2386L258.083 20.4766L257.768 20.5606H249.802L249.48 20.4766L249.249 20.2386L249.172 19.9306V15.2616L249.249 14.9466L249.48 14.7086L249.802 14.6246H249.851L250.166 14.5406L250.404 14.3096L250.481 13.9946V9.32562L250.565 9.01062L250.803 8.77962L251.118 8.69562H256.438L256.76 8.77962L256.991 9.01062L257.075 9.32562V13.9946L257.152 14.3096L257.39 14.5406L257.705 14.6246H257.761L258.076 14.7086L258.314 14.9466L258.391 15.2616V19.9306H258.398ZM255.759 13.3366V10.6416L255.682 10.3266L255.444 10.0886L255.129 10.0046H252.434L252.119 10.0886L251.888 10.3266L251.804 10.6416V13.3366L251.888 13.6516L252.119 13.8896L252.434 13.9736H255.129L255.444 13.8896L255.682 13.6516L255.759 13.3366ZM255.759 18.6076V15.9196L255.682 15.6116L255.444 15.3666L255.129 15.2896H252.434L252.119 15.3666L251.888 15.6116L251.804 15.9196V18.6076L251.888 18.9296L252.119 19.1606L252.434 19.2446H255.129L255.444 19.1606L255.682 18.9296L255.759 18.6076ZM267.603 9.36062H270.452L270.767 9.44462L271.005 9.67562L271.082 10.0046V13.9736L271.005 14.2956L270.767 14.5266L270.452 14.6246H267.603L267.295 14.5266L267.057 14.2956L266.973 13.9736V10.0046L267.057 9.67562L267.295 9.44462L267.603 9.36062ZM265.706 17.9216L265.622 18.2366L265.398 18.4816L265.02 18.5656H264.936L264.607 18.4816L264.376 18.2366L264.292 17.9216V11.3066L264.376 10.9986L264.607 10.7536L264.936 10.6696H265.02L265.398 10.7536L265.622 10.9986L265.706 11.3066V17.9216ZM263.137 17.9216L263.053 18.2366L262.808 18.4816L262.5 18.5656H262.465L262.038 18.4816L261.8 18.2366L261.716 17.9216V11.3066L261.8 10.9986L262.038 10.7536L262.465 10.6696H262.5L262.808 10.7536L263.053 10.9986L263.137 11.3066V17.9216ZM296.464 17.9286L296.45 18.1736L296.394 18.5236L296.289 18.8596L296.149 19.1886L295.96 19.4826L295.729 19.7486L295.47 19.9936L295.169 20.1966L294.861 20.3576L294.518 20.4696L294.175 20.5466L293.825 20.5676H289.219L288.869 20.4976L288.526 20.3926L288.211 20.2526L287.91 20.0636L287.644 19.8396L287.399 19.5736L287.203 19.2866L287.042 18.9646L286.923 18.6286L286.853 18.2856L286.825 17.9356V11.3346L286.839 11.0896L286.888 10.7396L286.993 10.4036L287.14 10.0746L287.329 9.78062L287.567 9.51462L287.826 9.26962L288.12 9.06662L288.435 8.90562L288.771 8.79362L289.121 8.71662L289.471 8.69562H294.077L294.434 8.76562L294.77 8.87062L295.092 9.01062L295.393 9.19962L295.659 9.42362L295.897 9.68962L296.1 9.97662L296.261 10.2986L296.38 10.6276L296.45 10.9776L296.478 11.3276V17.9286H296.464ZM295.141 17.9286V11.3276L295.092 10.9776L294.952 10.6556L294.728 10.3756L294.441 10.1656L294.112 10.0396L293.818 10.0046H289.457L289.114 10.0466L288.778 10.1936L288.505 10.4106L288.302 10.6906L288.169 11.0266L288.134 11.3206V17.9216L288.183 18.2716L288.323 18.5936L288.547 18.8736L288.834 19.0836L289.163 19.2096L289.464 19.2376H293.825L294.168 19.1956L294.497 19.0556L294.777 18.8386L294.98 18.5516L295.106 18.2156L295.141 17.9216V17.9286ZM304.479 15.2896L304.178 15.3736L303.954 15.5906L303.87 15.8986V19.9096L303.954 20.2386L304.199 20.4836L304.528 20.5676H308.483L308.812 20.4836L309.057 20.2386L309.141 19.9096V15.9476L309.057 15.6186L308.812 15.3736L308.483 15.2896H307.16L306.824 15.1986L306.586 14.9536L306.502 14.6246V9.34662L306.411 9.01762L306.166 8.77262L305.837 8.68862H304.514L304.185 8.77262L303.94 9.01762L303.856 9.34662V10.0116L303.94 10.3336L304.185 10.5786L304.514 10.6626H304.563L304.885 10.7466L305.088 10.9706L305.165 11.2646V14.6176L305.081 14.9466L304.836 15.1916L304.507 15.2826H304.458L304.479 15.2896ZM321.839 17.9286L321.825 18.1736L321.769 18.5236L321.664 18.8596L321.524 19.1886L321.335 19.4826L321.104 19.7486L320.845 19.9936L320.544 20.1966L320.236 20.3576L319.893 20.4696L319.55 20.5466L319.2 20.5676H314.594L314.244 20.4976L313.901 20.3926L313.586 20.2526L313.285 20.0636L313.019 19.8396L312.774 19.5736L312.578 19.2866L312.417 18.9646L312.298 18.6286L312.228 18.2856L312.2 17.9356V11.3346L312.214 11.0896L312.263 10.7396L312.368 10.4036L312.515 10.0746L312.704 9.78062L312.942 9.51462L313.201 9.26962L313.495 9.06662L313.81 8.90562L314.146 8.79362L314.496 8.71662L314.846 8.69562H319.452L319.809 8.76562L320.145 8.87062L320.467 9.01062L320.768 9.19962L321.034 9.42362L321.272 9.68962L321.475 9.97662L321.636 10.2986L321.755 10.6276L321.825 10.9776L321.853 11.3276V17.9286H321.839ZM320.516 17.9286V11.3276L320.467 10.9776L320.327 10.6556L320.103 10.3756L319.816 10.1656L319.487 10.0396L319.193 10.0046H314.832L314.489 10.0466L314.153 10.1936L313.88 10.4106L313.677 10.6906L313.544 11.0266L313.509 11.3206V17.9216L313.558 18.2716L313.698 18.5936L313.922 18.8736L314.209 19.0836L314.538 19.2096L314.839 19.2376H319.2L319.55 19.1956L319.879 19.0556L320.159 18.8386L320.362 18.5516L320.488 18.2156L320.523 17.9216L320.516 17.9286ZM329.854 15.2896L329.553 15.3736L329.329 15.5906L329.245 15.8986V19.9096L329.329 20.2386L329.574 20.4836L329.903 20.5676H333.858L334.187 20.4836L334.432 20.2386L334.516 19.9096V15.9476L334.432 15.6186L334.187 15.3736L333.858 15.2896H332.535L332.199 15.1986L331.961 14.9536L331.877 14.6246V9.34662L331.786 9.01762L331.541 8.77262L331.212 8.68862H329.889L329.56 8.77262L329.315 9.01762L329.231 9.34662V10.0116L329.315 10.3336L329.56 10.5786L329.889 10.6626H329.938L330.26 10.7466L330.463 10.9706L330.54 11.2646V14.6176L330.456 14.9466L330.211 15.1916L329.882 15.2826H329.833L329.854 15.2896Z" fill="#1F1F1F"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.1731 25.3697H19.8101V31.3967H132.097V25.3697H132.734V32.0337H19.1731V25.3697Z" fill="#1F1F1F"></path><path d="M39.8296 45.6667L38.1696 42.8167H37.0696V45.6667H36.1596V38.6967H38.4096C38.9363 38.6967 39.3796 38.7867 39.7396 38.9667C40.1063 39.1467 40.3796 39.39 40.5596 39.6967C40.7396 40.0033 40.8296 40.3533 40.8296 40.7467C40.8296 41.2267 40.6896 41.65 40.4096 42.0167C40.1363 42.3833 39.723 42.6267 39.1696 42.7467L40.9196 45.6667H39.8296ZM37.0696 42.0867H38.4096C38.903 42.0867 39.273 41.9667 39.5196 41.7267C39.7663 41.48 39.8896 41.1533 39.8896 40.7467C39.8896 40.3333 39.7663 40.0133 39.5196 39.7867C39.2796 39.56 38.9096 39.4467 38.4096 39.4467H37.0696V42.0867ZM44.6336 45.7567C44.1203 45.7567 43.6536 45.64 43.2336 45.4067C42.8203 45.1733 42.4936 44.8433 42.2536 44.4167C42.0203 43.9833 41.9036 43.4833 41.9036 42.9167C41.9036 42.3567 42.0236 41.8633 42.2636 41.4367C42.5103 41.0033 42.8436 40.6733 43.2636 40.4467C43.6836 40.2133 44.1536 40.0967 44.6736 40.0967C45.1936 40.0967 45.6636 40.2133 46.0836 40.4467C46.5036 40.6733 46.8336 41 47.0736 41.4267C47.3203 41.8533 47.4436 42.35 47.4436 42.9167C47.4436 43.4833 47.317 43.9833 47.0636 44.4167C46.817 44.8433 46.4803 45.1733 46.0536 45.4067C45.627 45.64 45.1536 45.7567 44.6336 45.7567ZM44.6336 44.9567C44.9603 44.9567 45.267 44.88 45.5536 44.7267C45.8403 44.5733 46.0703 44.3433 46.2436 44.0367C46.4236 43.73 46.5136 43.3567 46.5136 42.9167C46.5136 42.4767 46.427 42.1033 46.2536 41.7967C46.0803 41.49 45.8536 41.2633 45.5736 41.1167C45.2936 40.9633 44.9903 40.8867 44.6636 40.8867C44.3303 40.8867 44.0236 40.9633 43.7436 41.1167C43.4703 41.2633 43.2503 41.49 43.0836 41.7967C42.917 42.1033 42.8336 42.4767 42.8336 42.9167C42.8336 43.3633 42.9136 43.74 43.0736 44.0467C43.2403 44.3533 43.4603 44.5833 43.7336 44.7367C44.007 44.8833 44.307 44.9567 44.6336 44.9567ZM53.5001 40.1867V45.6667H52.5901V44.8567C52.4168 45.1367 52.1735 45.3567 51.8601 45.5167C51.5535 45.67 51.2135 45.7467 50.8401 45.7467C50.4135 45.7467 50.0301 45.66 49.6901 45.4867C49.3501 45.3067 49.0801 45.04 48.8801 44.6867C48.6868 44.3333 48.5901 43.9033 48.5901 43.3967V40.1867H49.4901V43.2767C49.4901 43.8167 49.6268 44.2333 49.9001 44.5267C50.1735 44.8133 50.5468 44.9567 51.0201 44.9567C51.5068 44.9567 51.8901 44.8067 52.1701 44.5067C52.4501 44.2067 52.5901 43.77 52.5901 43.1967V40.1867H53.5001ZM56.1466 40.9367V44.1667C56.1466 44.4333 56.2033 44.6233 56.3166 44.7367C56.4299 44.8433 56.6266 44.8967 56.9066 44.8967H57.5766V45.6667H56.7566C56.2499 45.6667 55.8699 45.55 55.6166 45.3167C55.3633 45.0833 55.2366 44.7 55.2366 44.1667V40.9367H54.5266V40.1867H55.2366V38.8067H56.1466V40.1867H57.5766V40.9367H56.1466ZM59.1492 39.2967C58.9758 39.2967 58.8292 39.2367 58.7092 39.1167C58.5892 38.9967 58.5292 38.85 58.5292 38.6767C58.5292 38.5033 58.5892 38.3567 58.7092 38.2367C58.8292 38.1167 58.9758 38.0567 59.1492 38.0567C59.3158 38.0567 59.4558 38.1167 59.5692 38.2367C59.6892 38.3567 59.7492 38.5033 59.7492 38.6767C59.7492 38.85 59.6892 38.9967 59.5692 39.1167C59.4558 39.2367 59.3158 39.2967 59.1492 39.2967ZM59.5892 40.1867V45.6667H58.6792V40.1867H59.5892ZM63.8101 40.0867C64.4768 40.0867 65.0168 40.29 65.4301 40.6967C65.8435 41.0967 66.0501 41.6767 66.0501 42.4367V45.6667H65.1501V42.5667C65.1501 42.02 65.0135 41.6033 64.7401 41.3167C64.4668 41.0233 64.0935 40.8767 63.6201 40.8767C63.1401 40.8767 62.7568 41.0267 62.4701 41.3267C62.1901 41.6267 62.0501 42.0633 62.0501 42.6367V45.6667H61.1401V40.1867H62.0501V40.9667C62.2301 40.6867 62.4735 40.47 62.7801 40.3167C63.0935 40.1633 63.4368 40.0867 63.8101 40.0867ZM69.7966 40.0967C70.2699 40.0967 70.6833 40.2 71.0366 40.4067C71.3966 40.6133 71.6633 40.8733 71.8366 41.1867V40.1867H72.7566V45.7867C72.7566 46.2867 72.6499 46.73 72.4366 47.1167C72.2233 47.51 71.9166 47.8167 71.5166 48.0367C71.1233 48.2567 70.6633 48.3667 70.1366 48.3667C69.4166 48.3667 68.8166 48.1967 68.3366 47.8567C67.8566 47.5167 67.5733 47.0533 67.4866 46.4667H68.3866C68.4866 46.8 68.6933 47.0667 69.0066 47.2667C69.3199 47.4733 69.6966 47.5767 70.1366 47.5767C70.6366 47.5767 71.0433 47.42 71.3566 47.1067C71.6766 46.7933 71.8366 46.3533 71.8366 45.7867V44.6367C71.6566 44.9567 71.3899 45.2233 71.0366 45.4367C70.6833 45.65 70.2699 45.7567 69.7966 45.7567C69.3099 45.7567 68.8666 45.6367 68.4666 45.3967C68.0733 45.1567 67.7633 44.82 67.5366 44.3867C67.3099 43.9533 67.1966 43.46 67.1966 42.9067C67.1966 42.3467 67.3099 41.8567 67.5366 41.4367C67.7633 41.01 68.0733 40.68 68.4666 40.4467C68.8666 40.2133 69.3099 40.0967 69.7966 40.0967ZM71.8366 42.9167C71.8366 42.5033 71.7533 42.1433 71.5866 41.8367C71.4199 41.53 71.1933 41.2967 70.9066 41.1367C70.6266 40.97 70.3166 40.8867 69.9766 40.8867C69.6366 40.8867 69.3266 40.9667 69.0466 41.1267C68.7666 41.2867 68.5433 41.52 68.3766 41.8267C68.2099 42.1333 68.1266 42.4933 68.1266 42.9067C68.1266 43.3267 68.2099 43.6933 68.3766 44.0067C68.5433 44.3133 68.7666 44.55 69.0466 44.7167C69.3266 44.8767 69.6366 44.9567 69.9766 44.9567C70.3166 44.9567 70.6266 44.8767 70.9066 44.7167C71.1933 44.55 71.4199 44.3133 71.5866 44.0067C71.7533 43.6933 71.8366 43.33 71.8366 42.9167ZM82.4404 45.6667H81.5304L77.8704 40.1167V45.6667H76.9604V38.6867H77.8704L81.5304 44.2267V38.6867H82.4404V45.6667ZM88.8517 40.1867V45.6667H87.9417V44.8567C87.7683 45.1367 87.525 45.3567 87.2117 45.5167C86.905 45.67 86.565 45.7467 86.1917 45.7467C85.765 45.7467 85.3817 45.66 85.0417 45.4867C84.7017 45.3067 84.4317 45.04 84.2317 44.6867C84.0383 44.3333 83.9417 43.9033 83.9417 43.3967V40.1867H84.8417V43.2767C84.8417 43.8167 84.9783 44.2333 85.2517 44.5267C85.525 44.8133 85.8983 44.9567 86.3717 44.9567C86.8583 44.9567 87.2417 44.8067 87.5217 44.5067C87.8017 44.2067 87.9417 43.77 87.9417 43.1967V40.1867H88.8517ZM96.9782 40.0867C97.4048 40.0867 97.7848 40.1767 98.1182 40.3567C98.4515 40.53 98.7148 40.7933 98.9082 41.1467C99.1015 41.5 99.1982 41.93 99.1982 42.4367V45.6667H98.2982V42.5667C98.2982 42.02 98.1615 41.6033 97.8882 41.3167C97.6215 41.0233 97.2582 40.8767 96.7982 40.8767C96.3248 40.8767 95.9482 41.03 95.6682 41.3367C95.3882 41.6367 95.2482 42.0733 95.2482 42.6467V45.6667H94.3482V42.5667C94.3482 42.02 94.2115 41.6033 93.9382 41.3167C93.6715 41.0233 93.3082 40.8767 92.8482 40.8767C92.3748 40.8767 91.9982 41.03 91.7182 41.3367C91.4382 41.6367 91.2982 42.0733 91.2982 42.6467V45.6667H90.3882V40.1867H91.2982V40.9767C91.4782 40.69 91.7182 40.47 92.0182 40.3167C92.3248 40.1633 92.6615 40.0867 93.0282 40.0867C93.4882 40.0867 93.8948 40.19 94.2482 40.3967C94.6015 40.6033 94.8648 40.9067 95.0382 41.3067C95.1915 40.92 95.4448 40.62 95.7982 40.4067C96.1515 40.1933 96.5448 40.0867 96.9782 40.0867ZM101.601 41.2067C101.788 40.88 102.061 40.6133 102.421 40.4067C102.781 40.2 103.191 40.0967 103.651 40.0967C104.144 40.0967 104.588 40.2133 104.981 40.4467C105.374 40.68 105.684 41.01 105.911 41.4367C106.138 41.8567 106.251 42.3467 106.251 42.9067C106.251 43.46 106.138 43.9533 105.911 44.3867C105.684 44.82 105.371 45.1567 104.971 45.3967C104.578 45.6367 104.138 45.7567 103.651 45.7567C103.178 45.7567 102.761 45.6533 102.401 45.4467C102.048 45.24 101.781 44.9767 101.601 44.6567V45.6667H100.691V38.2667H101.601V41.2067ZM105.321 42.9067C105.321 42.4933 105.238 42.1333 105.071 41.8267C104.904 41.52 104.678 41.2867 104.391 41.1267C104.111 40.9667 103.801 40.8867 103.461 40.8867C103.128 40.8867 102.818 40.97 102.531 41.1367C102.251 41.2967 102.024 41.5333 101.851 41.8467C101.684 42.1533 101.601 42.51 101.601 42.9167C101.601 43.33 101.684 43.6933 101.851 44.0067C102.024 44.3133 102.251 44.55 102.531 44.7167C102.818 44.8767 103.128 44.9567 103.461 44.9567C103.801 44.9567 104.111 44.8767 104.391 44.7167C104.678 44.55 104.904 44.3133 105.071 44.0067C105.238 43.6933 105.321 43.3267 105.321 42.9067ZM112.449 42.7167C112.449 42.89 112.439 43.0733 112.419 43.2667H108.039C108.072 43.8067 108.255 44.23 108.589 44.5367C108.929 44.8367 109.339 44.9867 109.819 44.9867C110.212 44.9867 110.539 44.8967 110.799 44.7167C111.065 44.53 111.252 44.2833 111.359 43.9767H112.339C112.192 44.5033 111.899 44.9333 111.459 45.2667C111.019 45.5933 110.472 45.7567 109.819 45.7567C109.299 45.7567 108.832 45.64 108.419 45.4067C108.012 45.1733 107.692 44.8433 107.459 44.4167C107.225 43.9833 107.109 43.4833 107.109 42.9167C107.109 42.35 107.222 41.8533 107.449 41.4267C107.675 41 107.992 40.6733 108.399 40.4467C108.812 40.2133 109.285 40.0967 109.819 40.0967C110.339 40.0967 110.799 40.21 111.199 40.4367C111.599 40.6633 111.905 40.9767 112.119 41.3767C112.339 41.77 112.449 42.2167 112.449 42.7167ZM111.509 42.5267C111.509 42.18 111.432 41.8833 111.279 41.6367C111.125 41.3833 110.915 41.1933 110.649 41.0667C110.389 40.9333 110.099 40.8667 109.779 40.8667C109.319 40.8667 108.925 41.0133 108.599 41.3067C108.279 41.6 108.095 42.0067 108.049 42.5267H111.509ZM114.56 41.0767C114.72 40.7633 114.947 40.52 115.24 40.3467C115.54 40.1733 115.903 40.0867 116.33 40.0867V41.0267H116.09C115.07 41.0267 114.56 41.58 114.56 42.6867V45.6667H113.65V40.1867H114.56V41.0767Z" fill="#1E293B"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M163.933 25.3697H164.57V31.3967H257.824V25.3697H258.461V32.0337H163.94V25.3697H163.933Z" fill="#1F1F1F"></path><path d="M173.488 44.1167H170.448L169.888 45.6667H168.928L171.448 38.7367H172.498L175.008 45.6667H174.048L173.488 44.1167ZM173.228 43.3767L171.968 39.8567L170.708 43.3767H173.228ZM175.766 42.9167C175.766 42.35 175.879 41.8567 176.106 41.4367C176.333 41.01 176.646 40.68 177.046 40.4467C177.453 40.2133 177.916 40.0967 178.436 40.0967C179.109 40.0967 179.663 40.26 180.096 40.5867C180.536 40.9133 180.826 41.3667 180.966 41.9467H179.986C179.893 41.6133 179.709 41.35 179.436 41.1567C179.169 40.9633 178.836 40.8667 178.436 40.8667C177.916 40.8667 177.496 41.0467 177.176 41.4067C176.856 41.76 176.696 42.2633 176.696 42.9167C176.696 43.5767 176.856 44.0867 177.176 44.4467C177.496 44.8067 177.916 44.9867 178.436 44.9867C178.836 44.9867 179.169 44.8933 179.436 44.7067C179.703 44.52 179.886 44.2533 179.986 43.9067H180.966C180.819 44.4667 180.526 44.9167 180.086 45.2567C179.646 45.59 179.096 45.7567 178.436 45.7567C177.916 45.7567 177.453 45.64 177.046 45.4067C176.646 45.1733 176.333 44.8433 176.106 44.4167C175.879 43.99 175.766 43.49 175.766 42.9167ZM181.84 42.9167C181.84 42.35 181.953 41.8567 182.18 41.4367C182.407 41.01 182.72 40.68 183.12 40.4467C183.527 40.2133 183.99 40.0967 184.51 40.0967C185.183 40.0967 185.737 40.26 186.17 40.5867C186.61 40.9133 186.9 41.3667 187.04 41.9467H186.06C185.967 41.6133 185.783 41.35 185.51 41.1567C185.243 40.9633 184.91 40.8667 184.51 40.8667C183.99 40.8667 183.57 41.0467 183.25 41.4067C182.93 41.76 182.77 42.2633 182.77 42.9167C182.77 43.5767 182.93 44.0867 183.25 44.4467C183.57 44.8067 183.99 44.9867 184.51 44.9867C184.91 44.9867 185.243 44.8933 185.51 44.7067C185.777 44.52 185.96 44.2533 186.06 43.9067H187.04C186.893 44.4667 186.6 44.9167 186.16 45.2567C185.72 45.59 185.17 45.7567 184.51 45.7567C183.99 45.7567 183.527 45.64 183.12 45.4067C182.72 45.1733 182.407 44.8433 182.18 44.4167C181.953 43.99 181.84 43.49 181.84 42.9167ZM190.644 45.7567C190.131 45.7567 189.664 45.64 189.244 45.4067C188.831 45.1733 188.504 44.8433 188.264 44.4167C188.031 43.9833 187.914 43.4833 187.914 42.9167C187.914 42.3567 188.034 41.8633 188.274 41.4367C188.521 41.0033 188.854 40.6733 189.274 40.4467C189.694 40.2133 190.164 40.0967 190.684 40.0967C191.204 40.0967 191.674 40.2133 192.094 40.4467C192.514 40.6733 192.844 41 193.084 41.4267C193.331 41.8533 193.454 42.35 193.454 42.9167C193.454 43.4833 193.328 43.9833 193.074 44.4167C192.828 44.8433 192.491 45.1733 192.064 45.4067C191.638 45.64 191.164 45.7567 190.644 45.7567ZM190.644 44.9567C190.971 44.9567 191.278 44.88 191.564 44.7267C191.851 44.5733 192.081 44.3433 192.254 44.0367C192.434 43.73 192.524 43.3567 192.524 42.9167C192.524 42.4767 192.438 42.1033 192.264 41.7967C192.091 41.49 191.864 41.2633 191.584 41.1167C191.304 40.9633 191.001 40.8867 190.674 40.8867C190.341 40.8867 190.034 40.9633 189.754 41.1167C189.481 41.2633 189.261 41.49 189.094 41.7967C188.928 42.1033 188.844 42.4767 188.844 42.9167C188.844 43.3633 188.924 43.74 189.084 44.0467C189.251 44.3533 189.471 44.5833 189.744 44.7367C190.018 44.8833 190.318 44.9567 190.644 44.9567ZM199.511 40.1867V45.6667H198.601V44.8567C198.428 45.1367 198.184 45.3567 197.871 45.5167C197.564 45.67 197.224 45.7467 196.851 45.7467C196.424 45.7467 196.041 45.66 195.701 45.4867C195.361 45.3067 195.091 45.04 194.891 44.6867C194.698 44.3333 194.601 43.9033 194.601 43.3967V40.1867H195.501V43.2767C195.501 43.8167 195.638 44.2333 195.911 44.5267C196.184 44.8133 196.558 44.9567 197.031 44.9567C197.518 44.9567 197.901 44.8067 198.181 44.5067C198.461 44.2067 198.601 43.77 198.601 43.1967V40.1867H199.511ZM203.717 40.0867C204.384 40.0867 204.924 40.29 205.337 40.6967C205.751 41.0967 205.957 41.6767 205.957 42.4367V45.6667H205.057V42.5667C205.057 42.02 204.921 41.6033 204.647 41.3167C204.374 41.0233 204.001 40.8767 203.527 40.8767C203.047 40.8767 202.664 41.0267 202.377 41.3267C202.097 41.6267 201.957 42.0633 201.957 42.6367V45.6667H201.047V40.1867H201.957V40.9667C202.137 40.6867 202.381 40.47 202.687 40.3167C203.001 40.1633 203.344 40.0867 203.717 40.0867ZM208.554 40.9367V44.1667C208.554 44.4333 208.61 44.6233 208.724 44.7367C208.837 44.8433 209.034 44.8967 209.314 44.8967H209.984V45.6667H209.164C208.657 45.6667 208.277 45.55 208.024 45.3167C207.77 45.0833 207.644 44.7 207.644 44.1667V40.9367H206.934V40.1867H207.644V38.8067H208.554V40.1867H209.984V40.9367H208.554ZM219.232 45.6667H218.322L214.662 40.1167V45.6667H213.752V38.6867H214.662L218.322 44.2267V38.6867H219.232V45.6667ZM225.644 40.1867V45.6667H224.734V44.8567C224.56 45.1367 224.317 45.3567 224.004 45.5167C223.697 45.67 223.357 45.7467 222.984 45.7467C222.557 45.7467 222.174 45.66 221.834 45.4867C221.494 45.3067 221.224 45.04 221.024 44.6867C220.83 44.3333 220.734 43.9033 220.734 43.3967V40.1867H221.634V43.2767C221.634 43.8167 221.77 44.2333 222.044 44.5267C222.317 44.8133 222.69 44.9567 223.164 44.9567C223.65 44.9567 224.034 44.8067 224.314 44.5067C224.594 44.2067 224.734 43.77 224.734 43.1967V40.1867H225.644ZM233.77 40.0867C234.197 40.0867 234.577 40.1767 234.91 40.3567C235.243 40.53 235.507 40.7933 235.7 41.1467C235.893 41.5 235.99 41.93 235.99 42.4367V45.6667H235.09V42.5667C235.09 42.02 234.953 41.6033 234.68 41.3167C234.413 41.0233 234.05 40.8767 233.59 40.8767C233.117 40.8767 232.74 41.03 232.46 41.3367C232.18 41.6367 232.04 42.0733 232.04 42.6467V45.6667H231.14V42.5667C231.14 42.02 231.003 41.6033 230.73 41.3167C230.463 41.0233 230.1 40.8767 229.64 40.8767C229.167 40.8767 228.79 41.03 228.51 41.3367C228.23 41.6367 228.09 42.0733 228.09 42.6467V45.6667H227.18V40.1867H228.09V40.9767C228.27 40.69 228.51 40.47 228.81 40.3167C229.117 40.1633 229.453 40.0867 229.82 40.0867C230.28 40.0867 230.687 40.19 231.04 40.3967C231.393 40.6033 231.657 40.9067 231.83 41.3067C231.983 40.92 232.237 40.62 232.59 40.4067C232.943 40.1933 233.337 40.0867 233.77 40.0867ZM238.393 41.2067C238.58 40.88 238.853 40.6133 239.213 40.4067C239.573 40.2 239.983 40.0967 240.443 40.0967C240.936 40.0967 241.38 40.2133 241.773 40.4467C242.166 40.68 242.476 41.01 242.703 41.4367C242.93 41.8567 243.043 42.3467 243.043 42.9067C243.043 43.46 242.93 43.9533 242.703 44.3867C242.476 44.82 242.163 45.1567 241.763 45.3967C241.37 45.6367 240.93 45.7567 240.443 45.7567C239.97 45.7567 239.553 45.6533 239.193 45.4467C238.84 45.24 238.573 44.9767 238.393 44.6567V45.6667H237.483V38.2667H238.393V41.2067ZM242.113 42.9067C242.113 42.4933 242.03 42.1333 241.863 41.8267C241.696 41.52 241.47 41.2867 241.183 41.1267C240.903 40.9667 240.593 40.8867 240.253 40.8867C239.92 40.8867 239.61 40.97 239.323 41.1367C239.043 41.2967 238.816 41.5333 238.643 41.8467C238.476 42.1533 238.393 42.51 238.393 42.9167C238.393 43.33 238.476 43.6933 238.643 44.0067C238.816 44.3133 239.043 44.55 239.323 44.7167C239.61 44.8767 239.92 44.9567 240.253 44.9567C240.593 44.9567 240.903 44.8767 241.183 44.7167C241.47 44.55 241.696 44.3133 241.863 44.0067C242.03 43.6933 242.113 43.3267 242.113 42.9067ZM249.241 42.7167C249.241 42.89 249.231 43.0733 249.211 43.2667H244.831C244.864 43.8067 245.047 44.23 245.381 44.5367C245.721 44.8367 246.131 44.9867 246.611 44.9867C247.004 44.9867 247.331 44.8967 247.591 44.7167C247.857 44.53 248.044 44.2833 248.151 43.9767H249.131C248.984 44.5033 248.691 44.9333 248.251 45.2667C247.811 45.5933 247.264 45.7567 246.611 45.7567C246.091 45.7567 245.624 45.64 245.211 45.4067C244.804 45.1733 244.484 44.8433 244.251 44.4167C244.017 43.9833 243.901 43.4833 243.901 42.9167C243.901 42.35 244.014 41.8533 244.241 41.4267C244.467 41 244.784 40.6733 245.191 40.4467C245.604 40.2133 246.077 40.0967 246.611 40.0967C247.131 40.0967 247.591 40.21 247.991 40.4367C248.391 40.6633 248.697 40.9767 248.911 41.3767C249.131 41.77 249.241 42.2167 249.241 42.7167ZM248.301 42.5267C248.301 42.18 248.224 41.8833 248.071 41.6367C247.917 41.3833 247.707 41.1933 247.441 41.0667C247.181 40.9333 246.891 40.8667 246.571 40.8667C246.111 40.8667 245.717 41.0133 245.391 41.3067C245.071 41.6 244.887 42.0067 244.841 42.5267H248.301ZM251.352 41.0767C251.512 40.7633 251.739 40.52 252.032 40.3467C252.332 40.1733 252.695 40.0867 253.122 40.0867V41.0267H252.882C251.862 41.0267 251.352 41.58 251.352 42.6867V45.6667H250.442V40.1867H251.352V41.0767Z" fill="#1E293B"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M286.804 25.3627H287.441V31.3897H333.753V25.3627H334.39V32.0267H286.811V25.3627H286.804Z" fill="#6B7280"></path><path d="M274.508 42.1667C274.508 41.4801 274.658 40.8667 274.958 40.3267C275.258 39.7801 275.668 39.3567 276.188 39.0567C276.708 38.7501 277.288 38.5967 277.928 38.5967C278.708 38.5967 279.374 38.7834 279.928 39.1567C280.488 39.5234 280.894 40.0434 281.148 40.7167H280.328C280.128 40.2434 279.821 39.8734 279.408 39.6067C279.001 39.3401 278.508 39.2067 277.928 39.2067C277.414 39.2067 276.951 39.3267 276.538 39.5667C276.131 39.8067 275.811 40.1534 275.578 40.6067C275.344 41.0534 275.228 41.5734 275.228 42.1667C275.228 42.7601 275.344 43.2801 275.578 43.7267C275.811 44.1734 276.131 44.5167 276.538 44.7567C276.951 44.9967 277.414 45.1167 277.928 45.1167C278.508 45.1167 279.001 44.9867 279.408 44.7267C279.821 44.4601 280.128 44.0934 280.328 43.6267H281.148C280.894 44.2934 280.488 44.8101 279.928 45.1767C279.368 45.5434 278.701 45.7267 277.928 45.7267C277.288 45.7267 276.708 45.5767 276.188 45.2767C275.668 44.9701 275.258 44.5467 274.958 44.0067C274.658 43.4667 274.508 42.8534 274.508 42.1667ZM285.142 40.1067C285.556 40.1067 285.926 40.1934 286.252 40.3667C286.586 40.5401 286.846 40.8067 287.032 41.1667C287.226 41.5201 287.322 41.9534 287.322 42.4667V45.6667H286.632V42.5467C286.632 41.9534 286.482 41.5001 286.182 41.1867C285.889 40.8734 285.486 40.7167 284.972 40.7167C284.446 40.7167 284.026 40.8834 283.712 41.2167C283.399 41.5501 283.242 42.0401 283.242 42.6867V45.6667H282.542V38.2667H283.242V41.1367C283.416 40.8101 283.669 40.5567 284.002 40.3767C284.342 40.1967 284.722 40.1067 285.142 40.1067ZM293.811 42.6567C293.811 42.8967 293.804 43.0801 293.791 43.2067H289.261C289.281 43.6201 289.381 43.9734 289.561 44.2667C289.741 44.5601 289.977 44.7834 290.271 44.9367C290.564 45.0834 290.884 45.1567 291.231 45.1567C291.684 45.1567 292.064 45.0467 292.371 44.8267C292.684 44.6067 292.891 44.3101 292.991 43.9367H293.731C293.597 44.4701 293.311 44.9067 292.871 45.2467C292.437 45.5801 291.891 45.7467 291.231 45.7467C290.717 45.7467 290.257 45.6334 289.851 45.4067C289.444 45.1734 289.124 44.8467 288.891 44.4267C288.664 44.0001 288.551 43.5034 288.551 42.9367C288.551 42.3701 288.664 41.8734 288.891 41.4467C289.117 41.0201 289.434 40.6934 289.841 40.4667C290.247 40.2401 290.711 40.1267 291.231 40.1267C291.751 40.1267 292.204 40.2401 292.591 40.4667C292.984 40.6934 293.284 41.0001 293.491 41.3867C293.704 41.7667 293.811 42.1901 293.811 42.6567ZM293.101 42.6367C293.107 42.2301 293.024 41.8834 292.851 41.5967C292.684 41.3101 292.454 41.0934 292.161 40.9467C291.867 40.8001 291.547 40.7267 291.201 40.7267C290.681 40.7267 290.237 40.8934 289.871 41.2267C289.504 41.5601 289.301 42.0301 289.261 42.6367H293.101ZM294.771 42.9367C294.771 42.3701 294.885 41.8767 295.111 41.4567C295.338 41.0301 295.651 40.7034 296.051 40.4767C296.451 40.2434 296.908 40.1267 297.421 40.1267C298.095 40.1267 298.648 40.2934 299.081 40.6267C299.521 40.9601 299.805 41.4134 299.931 41.9867H299.181C299.088 41.5934 298.885 41.2867 298.571 41.0667C298.265 40.8401 297.881 40.7267 297.421 40.7267C297.055 40.7267 296.725 40.8101 296.431 40.9767C296.138 41.1434 295.905 41.3934 295.731 41.7267C295.565 42.0534 295.481 42.4567 295.481 42.9367C295.481 43.4167 295.565 43.8234 295.731 44.1567C295.905 44.4901 296.138 44.7401 296.431 44.9067C296.725 45.0734 297.055 45.1567 297.421 45.1567C297.881 45.1567 298.265 45.0467 298.571 44.8267C298.885 44.6001 299.088 44.2867 299.181 43.8867H299.931C299.805 44.4467 299.521 44.8967 299.081 45.2367C298.641 45.5767 298.088 45.7467 297.421 45.7467C296.908 45.7467 296.451 45.6334 296.051 45.4067C295.651 45.1734 295.338 44.8467 295.111 44.4267C294.885 44.0001 294.771 43.5034 294.771 42.9367ZM304.174 45.6667L301.924 43.2167V45.6667H301.224V38.2667H301.924V42.6467L304.124 40.2067H305.104L302.514 42.9267L305.124 45.6667H304.174ZM314.043 45.6667H313.343L309.473 39.7867V45.6667H308.773V38.6767H309.473L313.343 44.5467V38.6767H314.043V45.6667ZM320.358 40.2067V45.6667H319.658V44.7067C319.498 45.0467 319.252 45.3067 318.918 45.4867C318.585 45.6667 318.212 45.7567 317.798 45.7567C317.145 45.7567 316.612 45.5567 316.198 45.1567C315.785 44.7501 315.578 44.1634 315.578 43.3967V40.2067H316.268V43.3167C316.268 43.9101 316.415 44.3634 316.708 44.6767C317.008 44.9901 317.415 45.1467 317.928 45.1467C318.455 45.1467 318.875 44.9801 319.188 44.6467C319.502 44.3134 319.658 43.8234 319.658 43.1767V40.2067H320.358ZM328.456 40.1067C329.096 40.1067 329.616 40.3101 330.016 40.7167C330.423 41.1167 330.626 41.7001 330.626 42.4667V45.6667H329.936V42.5467C329.936 41.9534 329.793 41.5001 329.506 41.1867C329.22 40.8734 328.83 40.7167 328.336 40.7167C327.823 40.7167 327.413 40.8867 327.106 41.2267C326.8 41.5667 326.646 42.0601 326.646 42.7067V45.6667H325.956V42.5467C325.956 41.9534 325.813 41.5001 325.526 41.1867C325.24 40.8734 324.846 40.7167 324.346 40.7167C323.833 40.7167 323.423 40.8867 323.116 41.2267C322.81 41.5667 322.656 42.0601 322.656 42.7067V45.6667H321.956V40.2067H322.656V41.1467C322.83 40.8067 323.076 40.5501 323.396 40.3767C323.716 40.1967 324.073 40.1067 324.466 40.1067C324.94 40.1067 325.353 40.2201 325.706 40.4467C326.066 40.6734 326.326 41.0067 326.486 41.4467C326.633 41.0134 326.883 40.6834 327.236 40.4567C327.596 40.2234 328.003 40.1067 328.456 40.1067ZM332.871 41.4167C333.051 41.0367 333.328 40.7267 333.701 40.4867C334.081 40.2467 334.528 40.1267 335.041 40.1267C335.541 40.1267 335.988 40.2434 336.381 40.4767C336.774 40.7034 337.081 41.0301 337.301 41.4567C337.528 41.8767 337.641 42.3667 337.641 42.9267C337.641 43.4867 337.528 43.9801 337.301 44.4067C337.081 44.8334 336.771 45.1634 336.371 45.3967C335.978 45.6301 335.534 45.7467 335.041 45.7467C334.521 45.7467 334.071 45.6301 333.691 45.3967C333.318 45.1567 333.044 44.8467 332.871 44.4667V45.6667H332.181V38.2667H332.871V41.4167ZM336.931 42.9267C336.931 42.4734 336.841 42.0834 336.661 41.7567C336.488 41.4234 336.248 41.1701 335.941 40.9967C335.634 40.8234 335.288 40.7367 334.901 40.7367C334.528 40.7367 334.184 40.8267 333.871 41.0067C333.564 41.1867 333.321 41.4434 333.141 41.7767C332.961 42.1101 332.871 42.4967 332.871 42.9367C332.871 43.3767 332.961 43.7634 333.141 44.0967C333.321 44.4301 333.564 44.6867 333.871 44.8667C334.184 45.0467 334.528 45.1367 334.901 45.1367C335.288 45.1367 335.634 45.0501 335.941 44.8767C336.248 44.6967 336.488 44.4401 336.661 44.1067C336.841 43.7667 336.931 43.3734 336.931 42.9267ZM343.869 42.6567C343.869 42.8967 343.862 43.0801 343.849 43.2067H339.319C339.339 43.6201 339.439 43.9734 339.619 44.2667C339.799 44.5601 340.036 44.7834 340.329 44.9367C340.622 45.0834 340.942 45.1567 341.289 45.1567C341.742 45.1567 342.122 45.0467 342.429 44.8267C342.742 44.6067 342.949 44.3101 343.049 43.9367H343.789C343.656 44.4701 343.369 44.9067 342.929 45.2467C342.496 45.5801 341.949 45.7467 341.289 45.7467C340.776 45.7467 340.316 45.6334 339.909 45.4067C339.502 45.1734 339.182 44.8467 338.949 44.4267C338.722 44.0001 338.609 43.5034 338.609 42.9367C338.609 42.3701 338.722 41.8734 338.949 41.4467C339.176 41.0201 339.492 40.6934 339.899 40.4667C340.306 40.2401 340.769 40.1267 341.289 40.1267C341.809 40.1267 342.262 40.2401 342.649 40.4667C343.042 40.6934 343.342 41.0001 343.549 41.3867C343.762 41.7667 343.869 42.1901 343.869 42.6567ZM343.159 42.6367C343.166 42.2301 343.082 41.8834 342.909 41.5967C342.742 41.3101 342.512 41.0934 342.219 40.9467C341.926 40.8001 341.606 40.7267 341.259 40.7267C340.739 40.7267 340.296 40.8934 339.929 41.2267C339.562 41.5601 339.359 42.0301 339.319 42.6367H343.159ZM345.85 41.1767C346.003 40.8367 346.237 40.5734 346.55 40.3867C346.87 40.2001 347.26 40.1067 347.72 40.1067V40.8367H347.53C347.023 40.8367 346.617 40.9734 346.31 41.2467C346.003 41.5201 345.85 41.9767 345.85 42.6167V45.6667H345.15V40.2067H345.85V41.1767ZM280.464 63.5267C279.837 62.9067 279.344 62.1134 278.984 61.1467C278.624 60.1734 278.444 59.1167 278.444 57.9767C278.444 56.8234 278.631 55.7534 279.004 54.7667C279.377 53.7801 279.901 52.9667 280.574 52.3267H281.304V52.3967C280.591 53.0967 280.047 53.9334 279.674 54.9067C279.307 55.8801 279.124 56.9034 279.124 57.9767C279.124 59.0367 279.301 60.0401 279.654 60.9867C280.007 61.9334 280.524 62.7567 281.204 63.4567V63.5267H280.464ZM287.773 61.6667H287.073L283.203 55.7867V61.6667H282.503V54.6767H283.203L287.073 60.5467V54.6767H287.773V61.6667ZM291.749 61.7467C291.236 61.7467 290.772 61.6334 290.359 61.4067C289.952 61.1734 289.629 60.8467 289.389 60.4267C289.156 60.0001 289.039 59.5034 289.039 58.9367C289.039 58.3701 289.159 57.8767 289.399 57.4567C289.639 57.0301 289.966 56.7034 290.379 56.4767C290.792 56.2434 291.256 56.1267 291.769 56.1267C292.282 56.1267 292.746 56.2434 293.159 56.4767C293.579 56.7034 293.906 57.0301 294.139 57.4567C294.379 57.8767 294.499 58.3701 294.499 58.9367C294.499 59.4967 294.379 59.9901 294.139 60.4167C293.899 60.8434 293.569 61.1734 293.149 61.4067C292.729 61.6334 292.262 61.7467 291.749 61.7467ZM291.749 61.1367C292.109 61.1367 292.442 61.0567 292.749 60.8967C293.056 60.7301 293.302 60.4834 293.489 60.1567C293.682 59.8234 293.779 59.4167 293.779 58.9367C293.779 58.4567 293.686 58.0534 293.499 57.7267C293.312 57.3934 293.066 57.1467 292.759 56.9867C292.452 56.8201 292.119 56.7367 291.759 56.7367C291.399 56.7367 291.066 56.8201 290.759 56.9867C290.452 57.1467 290.206 57.3934 290.019 57.7267C289.839 58.0534 289.749 58.4567 289.749 58.9367C289.749 59.4167 289.839 59.8234 290.019 60.1567C290.206 60.4834 290.449 60.7301 290.749 60.8967C291.056 61.0567 291.389 61.1367 291.749 61.1367ZM296.685 56.7967V60.1867C296.685 60.5201 296.748 60.7501 296.875 60.8767C297.002 61.0034 297.225 61.0667 297.545 61.0667H298.185V61.6667H297.435C296.942 61.6667 296.575 61.5534 296.335 61.3267C296.095 61.0934 295.975 60.7134 295.975 60.1867V56.7967H295.215V56.2067H295.975V54.8367H296.685V56.2067H298.185V56.7967H296.685ZM307.353 61.6667H306.653L302.783 55.7867V61.6667H302.083V54.6767H302.783L306.653 60.5467V54.6767H307.353V61.6667ZM313.879 58.6567C313.879 58.8967 313.872 59.0801 313.859 59.2067H309.329C309.349 59.6201 309.449 59.9734 309.629 60.2667C309.809 60.5601 310.046 60.7834 310.339 60.9367C310.632 61.0834 310.952 61.1567 311.299 61.1567C311.752 61.1567 312.132 61.0467 312.439 60.8267C312.752 60.6067 312.959 60.3101 313.059 59.9367H313.799C313.666 60.4701 313.379 60.9067 312.939 61.2467C312.506 61.5801 311.959 61.7467 311.299 61.7467C310.786 61.7467 310.326 61.6334 309.919 61.4067C309.512 61.1734 309.192 60.8467 308.959 60.4267C308.732 60.0001 308.619 59.5034 308.619 58.9367C308.619 58.3701 308.732 57.8734 308.959 57.4467C309.186 57.0201 309.502 56.6934 309.909 56.4667C310.316 56.2401 310.779 56.1267 311.299 56.1267C311.819 56.1267 312.272 56.2401 312.659 56.4667C313.052 56.6934 313.352 57.0001 313.559 57.3867C313.772 57.7667 313.879 58.1901 313.879 58.6567ZM313.169 58.6367C313.176 58.2301 313.092 57.8834 312.919 57.5967C312.752 57.3101 312.522 57.0934 312.229 56.9467C311.936 56.8001 311.616 56.7267 311.269 56.7267C310.749 56.7267 310.306 56.8934 309.939 57.2267C309.572 57.5601 309.369 58.0301 309.329 58.6367H313.169ZM320.1 58.6567C320.1 58.8967 320.093 59.0801 320.08 59.2067H315.55C315.57 59.6201 315.67 59.9734 315.85 60.2667C316.03 60.5601 316.266 60.7834 316.56 60.9367C316.853 61.0834 317.173 61.1567 317.52 61.1567C317.973 61.1567 318.353 61.0467 318.66 60.8267C318.973 60.6067 319.18 60.3101 319.28 59.9367H320.02C319.886 60.4701 319.6 60.9067 319.16 61.2467C318.726 61.5801 318.18 61.7467 317.52 61.7467C317.006 61.7467 316.546 61.6334 316.14 61.4067C315.733 61.1734 315.413 60.8467 315.18 60.4267C314.953 60.0001 314.84 59.5034 314.84 58.9367C314.84 58.3701 314.953 57.8734 315.18 57.4467C315.406 57.0201 315.723 56.6934 316.13 56.4667C316.536 56.2401 317 56.1267 317.52 56.1267C318.04 56.1267 318.493 56.2401 318.88 56.4667C319.273 56.6934 319.573 57.0001 319.78 57.3867C319.993 57.7667 320.1 58.1901 320.1 58.6567ZM319.39 58.6367C319.396 58.2301 319.313 57.8834 319.14 57.5967C318.973 57.3101 318.743 57.0934 318.45 56.9467C318.156 56.8001 317.836 56.7267 317.49 56.7267C316.97 56.7267 316.526 56.8934 316.16 57.2267C315.793 57.5601 315.59 58.0301 315.55 58.6367H319.39ZM321.06 58.9267C321.06 58.3667 321.174 57.8767 321.4 57.4567C321.627 57.0301 321.937 56.7034 322.33 56.4767C322.73 56.2434 323.18 56.1267 323.68 56.1267C324.16 56.1267 324.594 56.2434 324.98 56.4767C325.367 56.7101 325.65 57.0134 325.83 57.3867V54.2667H326.53V61.6667H325.83V60.4467C325.664 60.8267 325.39 61.1401 325.01 61.3867C324.63 61.6267 324.184 61.7467 323.67 61.7467C323.17 61.7467 322.72 61.6301 322.32 61.3967C321.927 61.1634 321.617 60.8334 321.39 60.4067C321.17 59.9801 321.06 59.4867 321.06 58.9267ZM325.83 58.9367C325.83 58.4967 325.74 58.1101 325.56 57.7767C325.38 57.4434 325.134 57.1867 324.82 57.0067C324.514 56.8267 324.174 56.7367 323.8 56.7367C323.414 56.7367 323.067 56.8234 322.76 56.9967C322.454 57.1701 322.21 57.4234 322.03 57.7567C321.857 58.0834 321.77 58.4734 321.77 58.9267C321.77 59.3734 321.857 59.7667 322.03 60.1067C322.21 60.4401 322.454 60.6967 322.76 60.8767C323.067 61.0501 323.414 61.1367 323.8 61.1367C324.174 61.1367 324.514 61.0467 324.82 60.8667C325.134 60.6867 325.38 60.4301 325.56 60.0967C325.74 59.7634 325.83 59.3767 325.83 58.9367ZM333.068 58.6567C333.068 58.8967 333.062 59.0801 333.048 59.2067H328.518C328.538 59.6201 328.638 59.9734 328.818 60.2667C328.998 60.5601 329.235 60.7834 329.528 60.9367C329.822 61.0834 330.142 61.1567 330.488 61.1567C330.942 61.1567 331.322 61.0467 331.628 60.8267C331.942 60.6067 332.148 60.3101 332.248 59.9367H332.988C332.855 60.4701 332.568 60.9067 332.128 61.2467C331.695 61.5801 331.148 61.7467 330.488 61.7467C329.975 61.7467 329.515 61.6334 329.108 61.4067C328.702 61.1734 328.382 60.8467 328.148 60.4267C327.922 60.0001 327.808 59.5034 327.808 58.9367C327.808 58.3701 327.922 57.8734 328.148 57.4467C328.375 57.0201 328.692 56.6934 329.098 56.4667C329.505 56.2401 329.968 56.1267 330.488 56.1267C331.008 56.1267 331.462 56.2401 331.848 56.4667C332.242 56.6934 332.542 57.0001 332.748 57.3867C332.962 57.7667 333.068 58.1901 333.068 58.6567ZM332.358 58.6367C332.365 58.2301 332.282 57.8834 332.108 57.5967C331.942 57.3101 331.712 57.0934 331.418 56.9467C331.125 56.8001 330.805 56.7267 330.458 56.7267C329.938 56.7267 329.495 56.8934 329.128 57.2267C328.762 57.5601 328.558 58.0301 328.518 58.6367H332.358ZM334.029 58.9267C334.029 58.3667 334.142 57.8767 334.369 57.4567C334.596 57.0301 334.906 56.7034 335.299 56.4767C335.699 56.2434 336.149 56.1267 336.649 56.1267C337.129 56.1267 337.562 56.2434 337.949 56.4767C338.336 56.7101 338.619 57.0134 338.799 57.3867V54.2667H339.499V61.6667H338.799V60.4467C338.632 60.8267 338.359 61.1401 337.979 61.3867C337.599 61.6267 337.152 61.7467 336.639 61.7467C336.139 61.7467 335.689 61.6301 335.289 61.3967C334.896 61.1634 334.586 60.8334 334.359 60.4067C334.139 59.9801 334.029 59.4867 334.029 58.9267ZM338.799 58.9367C338.799 58.4967 338.709 58.1101 338.529 57.7767C338.349 57.4434 338.102 57.1867 337.789 57.0067C337.482 56.8267 337.142 56.7367 336.769 56.7367C336.382 56.7367 336.036 56.8234 335.729 56.9967C335.422 57.1701 335.179 57.4234 334.999 57.7567C334.826 58.0834 334.739 58.4734 334.739 58.9267C334.739 59.3734 334.826 59.7667 334.999 60.1067C335.179 60.4401 335.422 60.6967 335.729 60.8767C336.036 61.0501 336.382 61.1367 336.769 61.1367C337.142 61.1367 337.482 61.0467 337.789 60.8667C338.102 60.6867 338.349 60.4301 338.529 60.0967C338.709 59.7634 338.799 59.3767 338.799 58.9367ZM340.797 63.5267V63.4567C341.477 62.7567 341.994 61.9334 342.347 60.9867C342.7 60.0401 342.877 59.0367 342.877 57.9767C342.877 56.9034 342.69 55.8801 342.317 54.9067C341.95 53.9334 341.41 53.0967 340.697 52.3967V52.3267H341.427C342.1 52.9667 342.624 53.7801 342.997 54.7667C343.37 55.7534 343.557 56.8234 343.557 57.9767C343.557 59.1167 343.377 60.1734 343.017 61.1467C342.657 62.1134 342.164 62.9067 341.537 63.5267H340.797Z" fill="#1F2937"></path></g><defs><clipPath id="clip0_1101_593"><rect width="350" height="65.0001" fill="white" transform="translate(0 0.666656)"></rect></clipPath></defs></svg>', 1)
    ])])) : _("", !0);
  }
}), e1 = {
  key: 0,
  class: "inline-block"
}, w6 = /* @__PURE__ */ m({
  __name: "Currency",
  props: {
    value: { default: void 0 },
    unit: { default: "cents" },
    whole: { type: Boolean, default: !0 },
    roundingMode: { default: X.HALF_EVEN }
  },
  setup(e) {
    const t = e, o = D(t, "value"), C = D(t, "unit"), i = D(t, "whole"), l = D(t, "roundingMode"), r = p(() => {
      const d = o.value;
      return d !== void 0 ? R6(d, C.value, i.value, l.value) ?? void 0 : void 0;
    });
    return (d, u) => o.value || o.value === 0 ? (a(), f("span", e1, Z(r.value), 1)) : _("", !0);
  }
}), n1 = {
  key: 0,
  class: "text-6xl font-bold text-success-600"
}, a1 = { key: 0 }, R1 = /* @__PURE__ */ m({
  __name: "CurrencyHero",
  props: {
    value: { default: void 0 },
    unit: { default: "cents" },
    whole: { type: Boolean, default: !0 },
    roundingMode: { default: X.HALF_EVEN },
    footnote: { default: void 0 }
  },
  setup(e) {
    return (t, o) => e.value ? (a(), f("div", n1, [
      b(w6, {
        value: e.value,
        unit: e.unit,
        whole: e.whole,
        "rounding-mode": e.roundingMode
      }, null, 8, ["value", "unit", "whole", "rounding-mode"]),
      e.footnote || t.$slots.footnote ? (a(), f("sup", a1, [
        A(t.$slots, "footnote", {}, () => [
          K(Z(e.footnote), 1)
        ])
      ])) : _("", !0)
    ])) : _("", !0);
  }
}), o1 = { class: "inline" }, L1 = { class: "text-[53%]" }, i1 = { key: 0 }, s1 = /* @__PURE__ */ m({
  __name: "CurrencyPerPeriod",
  props: {
    value: {},
    unit: { default: "cents" },
    period: { default: "months" },
    roundingMode: { default: X.HALF_EVEN },
    whole: { type: Boolean },
    footnoteAsterisk: { type: Boolean }
  },
  setup(e) {
    const { t } = q();
    return (o, C) => (a(), f("div", o1, [
      b(w6, {
        value: e.value,
        unit: e.unit,
        whole: e.whole,
        "rounding-mode": e.roundingMode
      }, null, 8, ["value", "unit", "whole", "rounding-mode"]),
      C[0] || (C[0] = g("span", { class: "text-[63%]" }, "/", -1)),
      g("span", L1, Z(n(t)(`currency.per_period.${e.period}`)), 1),
      A(o.$slots, "afterPeriod", {}, () => [
        e.footnoteAsterisk ? (a(), f("span", i1, Z(n(t)("footnote.asterisk")), 1)) : _("", !0)
      ])
    ]));
  }
});
function L6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      currency: {
        per_period: {
          days: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "day" } },
          months: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "mo" } },
          weeks: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "wk" } },
          years: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "yr" } }
        }
      }
    }
  });
}
typeof L6 == "function" && L6(s1);
const i6 = /* @__PURE__ */ m({
  __name: "DownloadContentButton",
  props: {
    severity: { default: void 0 },
    forceShow: { type: Boolean },
    filename: { default: void 0 },
    label: { default: "Download" },
    iframeSrc: { default: void 0 },
    content: {},
    document: {}
  },
  setup(e) {
    const t = e, o = Q6(), C = p(() => t.forceShow || o.value), i = p(
      () => "content" in t ? t.content : void 0
    ), l = p(
      () => "document" in t ? t.document : void 0
    ), r = p(() => t.iframeSrc != null ? !0 : i.value != null || l.value != null), d = p(() => t.filename == null ? l.value?.filename ?? "Download" : u(t.filename)), { t: u } = q({ useScope: "parent" }), V = () => {
      t.iframeSrc != null && window.open(t.iframeSrc, "_blank"), i.value != null && U6(i.value, d.value), l.value != null && z6(l.value.uri, d.value);
    };
    return ($, y) => {
      const B = k6;
      return C.value ? (a(), L(B, {
        key: 0,
        "aria-label": e.label || "download-button",
        icon: n(Y6),
        label: e.label,
        disabled: !r.value,
        severity: e.severity,
        onClick: V
      }, null, 8, ["aria-label", "icon", "label", "disabled", "severity"])) : _("", !0);
    };
  }
}), r1 = {
  key: 0,
  class: "h-6"
}, U1 = /* @__PURE__ */ m({
  __name: "DynamicProviderLogo",
  props: {
    provider: {},
    vertical: {}
  },
  setup(e) {
    const o = $6(e.provider), C = s(
      () => import("./AcimaLogo-Ch_KtPns.js")
    ), i = s(
      () => import("./AdsLogo-m7n5jW8V.js")
    ), l = s(
      () => import("./AffLogo-Bdm0-DqJ.js")
    ), r = s(
      () => import("./AquaLogo-BZCKbFNu.js")
    ), d = s(
      () => import("./BreadLogo-DbwuNOgE.js")
    ), u = s(
      () => import("./DividendLogo-Dacox6-b.js")
    ), V = s(
      () => import("./EasyPayLogo-CjDZrCNA.js")
    ), $ = s(
      () => import("./FortivaLogo-BvoY_UcS.js")
    ), y = s(
      () => import("./FoundationLogo-C86O_Zgg.js")
    ), B = s(
      () => import("./GenesisLogo-C-k-TMrU.js")
    ), S = s(
      () => import("./GreenskyLogo-DQJYg5Kc.js")
    ), k = s(
      () => import("./HFDLogo-D_PHzIHj.js")
    ), M = s(
      () => import("./LendingClubLogo-gmmdj2w_.js")
    ), P = s(
      () => import("./LendingPointLogo-COQiwyuH.js")
    ), w = s(
      () => import("./MomntLogo-BiLrDe8D.js")
    ), F = s(
      () => import("./PowerPayLogo-BgRbWzwZ.js")
    ), N = s(
      () => import("./ProceedLogo-BWLau1wM.js")
    ), x = s(
      () => import("./ProgressiveLogo-dZM4H0dV.js")
    ), c = s(
      () => import("./ServiceFinanceLogo-ORIYgkDR.js")
    ), v = s(
      () => import("./SnapLogo-BlrMBkct.js")
    ), E = s(
      () => import("./SonravaLogo-uElAtMyN.js")
    ), j = s(
      () => import("./SunlightLogo-LcIfuHOO.js")
    ), G = s(
      () => import("./SynchronyLogo-CgfxQGzj.js")
    ), O = s(
      () => import("./TgucLogo-CGND7Xo9.js")
    ), H = s(
      () => import("./UpgradeLogo-Mgl2bvL9.js")
    ), n6 = s(
      () => import("./TdBankLogo-WWFA5GX1.js")
    ), B6 = s(
      () => import("./WatercressLogo-Di-QigdY.js")
    ), S6 = s(
      () => import("./WellsFargoLogo-B4spRc_1.js")
    );
    return (F1, B1) => n(o) ? (a(), f("div", r1, [
      n(o) === "acima_standard" ? (a(), L(n(C), {
        key: 0,
        class: "h-full"
      })) : n(o) === "ads_standard" ? (a(), L(n(i), {
        key: 1,
        vertical: e.vertical,
        class: "h-full"
      }, null, 8, ["vertical"])) : n(o) === "aff_standard" ? (a(), L(n(l), {
        key: 2,
        class: "h-full"
      })) : n(o) === "aqua_standard" ? (a(), L(n(r), {
        key: 3,
        class: "h-full"
      })) : n(o) === "bread_standard" ? (a(), L(n(d), {
        key: 4,
        class: "h-full"
      })) : n(o) === "dividend_standard" ? (a(), L(n(u), {
        key: 5,
        class: "h-full"
      })) : n(o) === "easypay_standard" ? (a(), L(n(V), {
        key: 6,
        class: "h-full"
      })) : n(o) === "fortiva_standard" ? (a(), L(n($), {
        key: 7,
        class: "h-full"
      })) : n(o) === "foundation_standard" ? (a(), L(n(y), {
        key: 8,
        class: "h-full"
      })) : n(o) === "genesis_standard" ? (a(), L(n(B), {
        key: 9,
        class: "h-full"
      })) : n(o) === "greensky_standard" ? (a(), L(n(S), {
        key: 10,
        class: "h-full"
      })) : n(o) === "hfd_standard" ? (a(), L(n(k), {
        key: 11,
        class: "h-full"
      })) : n(o) === "lendingclub_standard" ? (a(), L(n(M), {
        key: 12,
        class: "h-full"
      })) : n(o) === "lendingpoint_standard" ? (a(), L(n(P), {
        key: 13,
        class: "h-full"
      })) : n(o) === "momnt_standard" ? (a(), L(n(w), {
        key: 14,
        class: "h-full"
      })) : n(o) === "powerpay_standard" ? (a(), L(n(F), {
        key: 15,
        class: "h-full"
      })) : n(o) === "proceed_standard" ? (a(), L(n(N), {
        key: 16,
        class: "h-full"
      })) : n(o) === "progressive_standard" ? (a(), L(n(x), {
        key: 17,
        class: "h-full"
      })) : n(o) === "service_finance_standard" ? (a(), L(n(c), {
        key: 18,
        class: "h-full"
      })) : n(o) === "snap_standard" ? (a(), L(n(v), {
        key: 19,
        class: "h-full"
      })) : n(o) === "sonrava_standard" ? (a(), L(n(E), {
        key: 20,
        class: "h-full"
      })) : n(o) === "sunlight_standard" ? (a(), L(n(j), {
        key: 21,
        class: "h-full"
      })) : n(o) === "tdbank_standard" ? (a(), L(n(n6), {
        key: 22,
        class: "h-full"
      })) : n(o) === "synchrony_standard" ? (a(), L(n(G), {
        key: 23,
        vertical: e.vertical,
        class: "h-full"
      }, null, 8, ["vertical"])) : n(o) === "tguc_standard" ? (a(), L(n(O), {
        key: 24,
        class: "h-full"
      })) : n(o) === "upgrade_standard" ? (a(), L(n(H), {
        key: 25,
        class: "h-full"
      })) : n(o) === "watercress_standard" ? (a(), L(n(B6), {
        key: 26,
        class: "h-full"
      })) : n(o) === "wells_fargo_standard" ? (a(), L(n(S6), {
        key: 27,
        class: "h-full"
      })) : _("", !0)
    ])) : _("", !0);
  }
}), F6 = /* @__PURE__ */ m({
  __name: "LenderName",
  props: {
    providerKey: {},
    vertical: {},
    displayType: {}
  },
  setup(e) {
    const t = e, { te: o } = t6(() => t.providerKey), C = D(t, "providerKey"), i = j6(C), l = p(() => {
      const r = t.displayType ?? "default";
      return t.vertical ? o(
        `${t.vertical}.providers.${i.value}.${r}`
      ) ? `${t.vertical}.providers.${i.value}.${r}` : `${t.vertical}.providers.${i.value}.default` : o(`providers.${i.value}.${r}`) ? `providers.${i.value}.${r}` : `providers.${i.value}.default`;
    });
    return (r, d) => {
      const u = I("i18n-t");
      return n(i) ? (a(), L(u, {
        key: l.value,
        keypath: l.value,
        tag: "span"
      }, {
        trade: T(() => [...d[0] || (d[0] = [
          K("™", -1)
        ])]),
        sup_reg: T(() => [...d[1] || (d[1] = [
          g("sup", null, "®", -1)
        ])]),
        _: 1
      }, 8, ["keypath"])) : _("", !0);
    };
  }
});
function s6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      elective_medical: {
        providers: {
          ads_standard: {
            default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MySmileCare" } }
          },
          aff_standard: {
            default: { t: 0, b: { t: 2, i: [{ t: 6, k: { t: 7, v: `providers.aff_standard.default
` } }] } }
          },
          bread_standard: {
            default: { t: 0, b: { t: 2, i: [{ t: 6, k: { t: 7, v: `providers.bread_standard.default
` } }] } }
          },
          fortiva_standard: {
            default: { t: 0, b: { t: 2, i: [{ t: 6, k: { t: 7, v: `providers.fortiva_standard.default
` } }] } }
          },
          genesis_standard: {
            default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Concora Credit" } }
          },
          lendingclub_standard: {
            default: { t: 0, b: { t: 2, i: [{ t: 6, k: { t: 7, v: `providers.lendingclub_standard.default
` } }] } }
          },
          proceed_standard: {
            default: { t: 0, b: { t: 2, i: [{ t: 6, k: { t: 7, v: `providers.proceed_standard.default
` } }] } }
          },
          sonrava_standard: {
            default: { t: 0, b: { t: 2, i: [{ t: 6, k: { t: 7, v: `providers.sonrava_standard.default
` } }] } }
          },
          synchrony_standard: {
            default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareCredit" } },
            long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareCredit LLC" } }
          }
        }
      },
      providers: {
        acima_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Acima Leasing" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Acima Digital, LLC" } }
        },
        ads_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bread" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bread Financial" } }
        },
        aff_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AFF" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "American First Finance" } }
        },
        aqua_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aqua Finance" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aqua Finance Company" } }
        },
        bread_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bread Pay" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bread Financial" } }
        },
        dividend_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dividend Finance" } }
        },
        easypay_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "EasyPay" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "EasyPay Finance" } }
        },
        fortiva_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3, v: "Fortiva" }, { t: 4, k: "sup_reg" }, { t: 3, v: " Retail Credit" }] } }
        },
        foundation_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Foundation" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Foundation Finance" } }
        },
        genesis_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3, v: "Concora" }, { t: 4, k: "sup_reg" }, { t: 3, v: " Credit" }] } }
        },
        greensky_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "GreenSky" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3, v: "GreenSky" }, { t: 4, k: "sup_reg" }] } }
        },
        kafene_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Kafene" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Kafene" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Kafene, Inc." } }
        },
        koalafi_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Koalafi" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Koalafi" } }
        },
        lendingclub_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "LendingClub" } }
        },
        lendingpoint_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "LendingPoint" } }
        },
        momnt_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Momnt" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Momnt Financial" } }
        },
        powerpay_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PowerPay" } }
        },
        proceed_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Proceed Finance" } }
        },
        progressive_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Progressive Leasing" } }
        },
        service_finance_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Service Finance" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Service Finance Company" } }
        },
        snap_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Snap" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Snap Finance" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Snap Finance, LLC" } }
        },
        sonrava_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sonrava Credit" } }
        },
        sunlight_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sunlight" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sunlight Financial" } }
        },
        synchrony_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SYNCB" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Synchrony Bank" } }
        },
        tdbank_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TD Bank, N.A." } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TD Retail Card Services" } }
        },
        tguc_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TGUC" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TGUC Financial" } }
        },
        upgrade_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Upgrade" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Upgrade Loan" } }
        },
        watercress_standard: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Watercress Financial" } }
        },
        wells_fargo_standard: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Wells Fargo" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Wells Fargo Bank, N.A." } }
        }
      }
    }
  });
}
typeof s6 == "function" && s6(F6);
const h = /* @__PURE__ */ m({
  __name: "LenderBankName",
  props: {
    providerKey: {},
    displayType: {}
  },
  setup(e) {
    const t = e, { te: o } = t6(() => t.providerKey), C = e6(() => t.providerKey), i = p(() => {
      const l = t.displayType ?? "default", r = (C.value?.providerBankId ?? "default").toLowerCase();
      return [
        `bank.${r}.${l}`,
        `bank.${r}.default`,
        `bank.${r}`,
        `bank.default.${l}`,
        "bank.default.default",
        "bank.default"
      ].find((d) => o(d));
    });
    return (l, r) => {
      const d = I("i18n-t");
      return i.value ? (a(), L(d, {
        key: i.value,
        keypath: i.value,
        tag: "span"
      }, null, 8, ["keypath"])) : _("", !0);
    };
  }
});
function r6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "acima_standard_en",
    resource: {
      bank: {
        default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Acima Digital, LLC" } }
      }
    }
  });
}
function l6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "genesis_standard_en",
    resource: {
      bank: {
        celtic: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Celtic Bank" } }
        },
        feb: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "FEB" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "First Electronic Bank, Member FDIC" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'First Electronic Bank ("BANK"), Member FDIC' } },
          short: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "First Electronic Bank" } }
        },
        tbom: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TBOM" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The Bank of Missouri" } }
        }
      }
    }
  });
}
function d6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "progressive_standard_en",
    resource: {
      bank: {
        default: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Progressive" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Progressive Leasing" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Prog Leasing, LLC ("Progressive")' } },
          short: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prog Leasing, LLC" } }
        }
      }
    }
  });
}
function c6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "snap_standard_en",
    resource: {
      bank: {
        default: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Snap Finance" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Snap Finance, LLC" } },
          short: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Snap" } }
        },
        qb: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Quill Bank" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Quill Bank, Member FDIC" } }
        }
      }
    }
  });
}
function C6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "aff_standard_en",
    resource: {
      bank: {
        default: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AFF" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "American First Finance" } }
        },
        finwise: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "FinWise Bank" } }
        }
      }
    }
  });
}
function u6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "fortiva_standard_en",
    resource: {
      bank: {
        default: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TBOM" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The Bank of Missouri" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'The Bank of Missouri ("TBOM")' } }
        }
      }
    }
  });
}
function f6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "kafene_standard_en",
    resource: {
      bank: {
        default: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TBOM" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The Bank of Missouri" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'The Bank of Missouri ("TBOM")' } }
        }
      }
    }
  });
}
function _6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "koalafi_standard_en",
    resource: {
      bank: {
        default: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TBOM" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The Bank of Missouri" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'The Bank of Missouri ("TBOM")' } }
        }
      }
    }
  });
}
function p6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "synchrony_standard_en",
    resource: {
      bank: {
        default: {
          abbreviation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SYNCB" } },
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Synchrony Bank" } },
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Synchrony Bank ("SYNCB")' } },
          short: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Synchrony" } }
        }
      }
    }
  });
}
function v6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "ads_standard_en",
    resource: {
      bank: {
        default: {
          default: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comenity Capital Bank" } },
          short: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comenity Bank" } }
        }
      }
    }
  });
}
function m6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "tdbank_standard_en",
    resource: {
      bank: {
        default: {
          long: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'TD Bank, N.A. ("TD")' } }
        }
      }
    }
  });
}
typeof r6 == "function" && r6(h);
typeof l6 == "function" && l6(h);
typeof d6 == "function" && d6(h);
typeof c6 == "function" && c6(h);
typeof C6 == "function" && C6(h);
typeof u6 == "function" && u6(h);
typeof f6 == "function" && f6(h);
typeof _6 == "function" && _6(h);
typeof p6 == "function" && p6(h);
typeof v6 == "function" && v6(h);
typeof m6 == "function" && m6(h);
const l1 = {
  key: 0,
  class: "inline-block"
}, z = /* @__PURE__ */ m({
  __name: "LenderAccountName",
  props: /* @__PURE__ */ Z6({
    providerKey: {},
    vertical: {}
  }, {
    cardName: {},
    cardNameModifiers: {}
  }),
  emits: ["update:cardName"],
  setup(e) {
    const t = e, { te: o, t: C } = t6(() => t.providerKey), i = e6(() => t.providerKey), l = R(e, "cardName"), r = p(() => i.value?.providerCardProductName ? {
      cardName: i.value?.providerCardProductName,
      isLocalized: !1,
      keyPath: ""
    } : o("merchant.card_name") ? {
      cardName: C("merchant.card_name"),
      isLocalized: !0,
      keyPath: "merchant.card_name"
    } : o("defaults.card_name") ? {
      cardName: C("defaults.card_name"),
      isLocalized: !0,
      keyPath: "defaults.card_name"
    } : { cardName: "", isLocalized: !1, keyPath: "" });
    return J(
      () => r.value.cardName,
      (d) => {
        l.value = d;
      },
      { immediate: !0 }
    ), (d, u) => {
      const V = I("i18n-t");
      return n(o)("account_name") ? (a(), f("div", l1, [
        b(V, { keypath: "account_name" }, M6({
          lender: T(() => [
            b(F6, {
              "provider-key": e.providerKey,
              vertical: e.vertical
            }, null, 8, ["provider-key", "vertical"])
          ]),
          _: 2
        }, [
          r.value.isLocalized ? {
            name: "cardName",
            fn: T(() => [
              b(V, {
                keypath: r.value.keyPath,
                tag: "span"
              }, {
                trade: T(() => [...u[0] || (u[0] = [
                  g("sup", null, "™", -1)
                ])]),
                _: 1
              }, 8, ["keypath"])
            ]),
            key: "0"
          } : {
            name: "cardName",
            fn: T(() => [
              K(Z(r.value.cardName), 1)
            ]),
            key: "1"
          }
        ]), 1024)
      ])) : _("", !0);
    };
  }
});
function H6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      account_name: { t: 0, b: { t: 2, i: [{ t: 4, k: "lender" }] } }
    }
  });
}
function V6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "synchrony_standard_en",
    resource: {
      account_name: { t: 0, b: { t: 2, i: [{ t: 4, k: "cardName" }] } }
    }
  });
}
function b6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "genesis_standard_en",
    resource: {
      account_name: { t: 0, b: { t: 2, i: [{ t: 4, k: "lender" }, { t: 3, v: " " }, { t: 4, k: "cardName" }] } }
    }
  });
}
function y6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "ads_standard_en",
    resource: {
      account_name: { t: 0, b: { t: 2, i: [{ t: 4, k: "cardName" }] } }
    }
  });
}
typeof H6 == "function" && H6(z);
typeof V6 == "function" && V6(z);
typeof b6 == "function" && b6(z);
typeof y6 == "function" && y6(z);
const z1 = /* @__PURE__ */ m({
  __name: "Percent",
  props: {
    value: {},
    minimumFractionDigits: {},
    maximumFractionDigits: {}
  },
  setup(e) {
    const t = e, o = p(
      () => G6(t.value, {
        maximumFractionDigits: t.maximumFractionDigits,
        minimumFractionDigits: t.minimumFractionDigits
      })
    );
    return (C, i) => Z(o.value);
  }
}), j1 = (e) => p(() => x6(e)), d1 = ["id"], c1 = ["aria-labelledby"], G1 = /* @__PURE__ */ m({
  __name: "ProviderDecisionDataTable",
  props: {
    rows: {},
    rowLength: { default: 4 }
  },
  setup(e) {
    const t = e;
    q({ useScope: "parent" });
    const o = p(() => {
      const i = [], l = [...t.rows].filter(
        (r) => r.visible == null || r.visible
      );
      for (; l.length > t.rowLength; )
        i.push(l.splice(0, t.rowLength));
      return l.length > 0 && i.push(l), i;
    }), C = (i) => i.map((l) => l.id).join(",");
    return (i, l) => {
      const r = I("i18n-t");
      return a(), f("div", {
        style: D6({
          "--cols": o.value.length
        }),
        class: "provider-grid grid grid-cols-[repeat(var(--cols),minmax(0,1fr))] gap-2 rounded-lg bg-gray-100 p-6 shadow"
      }, [
        (a(!0), f(W, null, a6(o.value, (d) => (a(), f("div", {
          key: C(d),
          class: "provider-column grid grid-cols-1 sm:grid-cols-[minmax(0,1fr)_max-content] place-content-start gap-4 place-self-start"
        }, [
          (a(!0), f(W, null, a6(d, (u) => (a(), f(W, {
            key: u.id ?? u.label
          }, [
            g("div", {
              id: u.id,
              class: "sm:text-right font-medium"
            }, [
              A(i.$slots, `${u.id}Label`, {}, () => [
                u.label ? (a(), L(r, {
                  key: 0,
                  keypath: u.label,
                  tag: "span"
                }, null, 8, ["keypath"])) : _("", !0)
              ])
            ], 8, d1),
            g("div", {
              "aria-labelledby": u.id,
              class: "font-light"
            }, [
              A(i.$slots, `${u.id}Value`, {}, () => [
                K(Z(u.value), 1)
              ])
            ], 8, c1)
          ], 64))), 128))
        ]))), 128))
      ], 4);
    };
  }
}), C1 = { class: "note note-required" }, u1 = { class: "text-danger-600" }, f1 = /* @__PURE__ */ m({
  __name: "RequiredNote",
  setup(e) {
    const { t } = q();
    return (o, C) => (a(), f("div", C1, [
      g("span", u1, Z(n(t)("icon")), 1),
      K(" " + Z(n(t)("message")), 1)
    ]));
  }
});
function g6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      icon: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `*
` } },
      message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Required Field
` } }
    }
  });
}
typeof g6 == "function" && g6(f1);
const _1 = { class: "flex items-center justify-center gap-1 flex-row gap-2" }, p1 = {
  key: 0,
  class: "flex h-8 items-center"
}, v1 = {
  key: 1,
  class: "border-r border-surface-600 h-6"
}, m1 = { key: 2 }, H1 = {
  id: "viewTitle",
  class: "text-xl"
}, O1 = /* @__PURE__ */ m({
  __name: "ViewTitle",
  props: {
    providerKey: { default: void 0 },
    vertical: { default: "retail" },
    title: {}
  },
  setup(e) {
    const t = s(
      () => import("./AcimaLogo-Ch_KtPns.js")
    ), o = s(
      () => import("./AffLogo-Bdm0-DqJ.js")
    ), C = s(
      () => import("./BreadLogo-DbwuNOgE.js")
    ), i = s(
      () => import("./EasyPayLogo-CjDZrCNA.js")
    ), l = s(
      () => import("./GenesisLogo-C-k-TMrU.js")
    ), r = s(
      () => import("./HFDLogo-D_PHzIHj.js")
    ), d = s(
      () => import("./KafeneLogo-DLp9KYox.js")
    ), u = s(
      () => import("./KoalafiLogo-BrXb2-he.js")
    ), V = s(
      () => import("./LendingClubLogo-gmmdj2w_.js")
    ), $ = s(
      () => import("./ProceedLogo-BWLau1wM.js")
    ), y = s(
      () => import("./ProgressiveLogo-dZM4H0dV.js")
    ), B = s(
      () => import("./SnapLogo-BlrMBkct.js")
    ), S = s(
      () => import("./SonravaLogo-uElAtMyN.js")
    ), k = s(
      () => import("./SynchronyLogo-CgfxQGzj.js")
    ), M = s(
      () => import("./TdBankLogo-WWFA5GX1.js")
    ), P = s(
      () => import("./FortivaLogo-BvoY_UcS.js")
    ), w = s(
      () => import("./AdsLogo-m7n5jW8V.js")
    ), F = e, N = D(F, "title"), x = D(F, "providerKey"), c = p(() => {
      if (x.value)
        return $6(x.value);
    });
    return (v, E) => (a(), f("div", _1, [
      c.value ? (a(), f("div", p1, [
        c.value === "acima_standard" ? (a(), L(n(t), {
          key: 0,
          class: "h-full"
        })) : c.value === "aff_standard" ? (a(), L(n(o), {
          key: 1,
          class: "h-full"
        })) : c.value === "bread_standard" ? (a(), L(n(C), {
          key: 2,
          class: "h-full"
        })) : c.value === "fortiva_standard" ? (a(), L(n(P), {
          key: 3,
          class: "h-full"
        })) : c.value === "hfd_standard" ? (a(), L(n(r), {
          key: 4,
          class: "h-full"
        })) : c.value === "koalafi_standard" ? (a(), L(n(u), {
          key: 5,
          class: "h-full"
        })) : c.value === "kafene_standard" ? (a(), L(n(d), {
          key: 6,
          class: "h-full"
        })) : c.value === "lendingclub_standard" ? (a(), L(n(V), {
          key: 7,
          class: "h-full"
        })) : c.value === "proceed_standard" ? (a(), L(n($), {
          key: 8,
          class: "h-full"
        })) : c.value === "sonrava_standard" ? (a(), L(n(S), {
          key: 9,
          class: "h-full"
        })) : c.value === "synchrony_standard" ? (a(), L(n(k), {
          key: 10,
          vertical: e.vertical,
          class: A6([
            "max-h-6",
            {
              "h-4": e.vertical === "elective_medical",
              "h-full": e.vertical !== "elective_medical"
            }
          ])
        }, null, 8, ["vertical", "class"])) : c.value === "genesis_standard" ? (a(), L(n(l), {
          key: 11,
          class: "h-full"
        })) : c.value === "tdbank_standard" ? (a(), L(n(M), {
          key: 12,
          class: "h-full"
        })) : c.value === "progressive_standard" ? (a(), L(n(y), {
          key: 13,
          class: "h-full"
        })) : c.value === "snap_standard" ? (a(), L(n(B), {
          key: 14,
          class: "h-full"
        })) : c.value === "easypay_standard" ? (a(), L(n(i), {
          key: 15,
          class: "h-full"
        })) : c.value === "ads_standard" ? (a(), L(n(w), {
          key: 16,
          vertical: e.vertical,
          class: "h-full"
        }, null, 8, ["vertical"])) : _("", !0)
      ])) : _("", !0),
      c.value && N.value ? (a(), f("div", v1)) : _("", !0),
      N.value ? (a(), f("div", m1, [
        g("span", H1, Z(N.value), 1)
      ])) : _("", !0)
    ]));
  }
}), V1 = {
  key: 0,
  class: "grid size-[80px] rounded-full bg-primary-300 text-5xl"
}, W1 = /* @__PURE__ */ m({
  __name: "IconHero",
  props: {
    icon: {}
  },
  setup(e) {
    return (t, o) => e.icon ? (a(), f("div", V1, [
      b(n(X6), {
        icon: e.icon,
        class: "place-self-center"
      }, null, 8, ["icon"])
    ])) : _("", !0);
  }
}), b1 = (e, t) => {
  const o = (i, l) => () => {
    const r = i.innerHeight + Math.round(i.scrollY), d = l.body.offsetHeight;
    r >= d && t();
  }, C = (i) => {
    try {
      const l = i.contentWindow, r = l?.document;
      l && r ? (l.innerHeight >= r.body.offsetHeight && t(), r.addEventListener("scroll", o(l, r))) : t();
    } catch {
      t();
    }
  };
  J(e, (i) => {
    i && i.addEventListener("load", () => C(i));
  });
}, y1 = (e) => {
  const { frame: t, pdf: o, image: C, providerKey: i, requireScroll: l } = E6(e), r = O6("useLoadTermsListener"), d = U(!0), u = U(!1), V = e6(i), $ = p(
    () => V?.value?.properties?.applyTermsScrollRequired
  ), y = p(() => $.value !== void 0 ? $.value : l?.value ? l.value : !1);
  return {
    onError: (k) => {
      W6(k), r.error(
        `Content failed to load for ${t?.value ?? o?.value ?? C?.value}`
      ), u.value = !0, d.value = !1;
    },
    onContentLoaded: (k, M, P) => {
      if (y.value || M(), d.value = !1, !P.value) {
        const w = k.value?.parentElement;
        w && w.clientHeight >= w.scrollHeight && M();
      }
    },
    loading: d,
    error: u
  };
}, g1 = {
  key: 0,
  class: "sticky top-0 ml-auto w-max"
}, h1 = {
  key: 1,
  class: "sticky top-0 ml-auto w-max"
}, k1 = { class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }, M1 = {
  role: "alert",
  "aria-labelledby": "terms-error-title",
  "aria-describedby": "terms-error-description",
  class: "flex flex-col items-center justify-center space-y-6"
}, Z1 = ["src"], $1 = ["src"], w1 = /* @__PURE__ */ m({
  __name: "TermsModal",
  props: /* @__PURE__ */ Z6({
    pdf: { default: void 0 },
    image: { default: void 0 },
    frame: { default: void 0 },
    document: { default: void 0 },
    collectAgreement: { type: Boolean, default: !0 },
    providerKey: { default: void 0 },
    title: { default: void 0 },
    requireScroll: { type: Boolean, default: !1 },
    withDownload: { type: Boolean, default: !1 }
  }, {
    visible: { type: Boolean },
    visibleModifiers: {},
    accepted: { type: Boolean },
    acceptedModifiers: {},
    read: { type: Boolean },
    readModifiers: {}
  }),
  emits: ["update:visible", "update:accepted", "update:read"],
  setup(e) {
    const t = K6(), o = e, C = U(), i = R(e, "visible"), l = R(e, "accepted"), r = R(e, "read"), d = J6(), u = p(
      () => o.withDownload && !d.value && o.document
    ), { onError: V, onContentLoaded: $, loading: y, error: B } = y1(o), S = U(), k = () => r.value = !0;
    b1(S, k);
    const { t: M } = q(), P = (c) => {
      r.value = !1, V(c);
    }, w = () => {
      l.value = !0;
    }, F = () => {
      $(C, k, S);
    }, N = (c) => {
      r.value || (r.value = c.arrivedState.bottom);
    }, x = p(() => {
      if (o.pdf)
        return o.pdf;
      if (o.document?.mediaType === "application/pdf")
        return o.document.uri;
    });
    return J(i, (c) => {
      c && t.inlineTerms && I6().then(F);
    }), (c, v) => {
      const E = I("i18n-t"), j = T6, G = k6, O = P6;
      return a(), L(O, {
        id: "termsModal",
        modelValue: i.value,
        "onUpdate:modelValue": v[5] || (v[5] = (H) => i.value = H),
        class: "md:w-[75vw] xl:w-[50vw]",
        "cancel-button-label": n(M)("buttons.cancel"),
        "accept-button-label": n(M)("buttons.accept"),
        loading: n(y) || !r.value,
        header: e.title,
        onModalAccept: v[6] || (v[6] = (H) => w()),
        onScroll: N
      }, M6({
        default: T(() => [
          g("div", {
            ref_key: "marker",
            ref: C,
            class: "hidden"
          }, null, 512),
          u.value ? Y((a(), f("div", g1, [
            b(n(i6), {
              "data-button": "download-button",
              label: "",
              severity: "secondary",
              document: e.document
            }, null, 8, ["document"])
          ], 512)), [
            [Q, !n(y)]
          ]) : _("", !0),
          e.frame && e.withDownload ? Y((a(), f("div", h1, [
            b(n(i6), {
              "data-button": "download-button",
              label: "",
              severity: "secondary",
              "force-show": "",
              "iframe-src": e.frame
            }, null, 8, ["iframe-src"])
          ], 512)), [
            [Q, !n(y)]
          ]) : _("", !0),
          Y(g("div", k1, [
            b(n(q6))
          ], 512), [
            [Q, n(y)]
          ]),
          n(B) ? A(c.$slots, "error", { key: 2 }, () => [
            g("div", M1, [
              b(E, {
                id: "terms-error-title",
                keypath: "error.title",
                tag: "h2"
              }),
              b(E, {
                id: "terms-error-description",
                keypath: "error.description",
                tag: "p"
              })
            ])
          ]) : _("", !0),
          e.image ? (a(), f("img", {
            key: 3,
            src: e.image,
            alt: "",
            onLoad: v[0] || (v[0] = (H) => F()),
            onError: v[1] || (v[1] = (H) => P())
          }, null, 40, Z1)) : x.value ? (a(), L(j, {
            key: 4,
            url: x.value,
            onLoaded: v[2] || (v[2] = (H) => F()),
            onError: v[3] || (v[3] = (H) => P(H))
          }, null, 8, ["url"])) : e.frame ? (a(), f("iframe", {
            key: 5,
            ref_key: "iframe",
            ref: S,
            title: "",
            src: e.frame,
            class: "h-[60vh] w-full",
            onLoad: v[4] || (v[4] = (H) => F())
          }, null, 40, $1)) : c.$slots.inlineTerms ? A(c.$slots, "inlineTerms", { key: 6 }) : _("", !0)
        ]),
        _: 2
      }, [
        e.collectAgreement ? void 0 : {
          name: "footer",
          fn: T((H) => [
            A(c.$slots, "footer", {
              accept: H.accept,
              reject: H.reject
            }, () => [
              b(G, {
                label: n(M)("buttons.close"),
                onClick: (n6) => H.reject()
              }, null, 8, ["label", "onClick"])
            ])
          ]),
          key: "0"
        }
      ]), 1032, ["modelValue", "cancel-button-label", "accept-button-label", "loading", "header"]);
    };
  }
});
function h6(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "en",
    resource: {
      buttons: {
        accept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "I Agree" } },
        cancel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Back" } },
        close: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Close" } }
      },
      error: {
        description: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `There was an error loading the required documents. Please try again.
` } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Error Loading Required Documents" } }
      }
    }
  });
}
typeof h6 == "function" && h6(w1);
export {
  F6 as _,
  h as a,
  U1 as b,
  w6 as c,
  z1 as d,
  q1 as e,
  R1 as f,
  s1 as g,
  i6 as h,
  W1 as i,
  z as j,
  G1 as k,
  f1 as l,
  w1 as m,
  O1 as n,
  j1 as o,
  y1 as p,
  b1 as u
};
//# sourceMappingURL=TermsModal-CBEOKaIP.js.map
